var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/atoms/Input/FieldBase/FieldBase.tsx
import { forwardRef as forwardRef7 } from "react";
import { combineStyles as combineStyles6, CompositionValidator as CompositionValidator2, spacing as spacing3 } from "@instacart/ids-core";

// src/atoms/Input/FieldBase/validations.tsx
import {
  CompositionOrderError as CompositionOrderError2,
  CompositionTooManyItemsError as CompositionTooManyItemsError2,
  CompositionTooFewItemsError,
  unstableCoachmark
} from "@instacart/ids-core";

// src/molecules/Input/InputWrapper/InputWrapper.tsx
import { combineStyles as combineStyles3, CompositionValidator } from "@instacart/ids-core";

// src/molecules/Input/InputWrapper/validations.tsx
import {
  CompositionOrderError,
  CompositionTooManyItemsError,
  CompositionXorItemsError
} from "@instacart/ids-core";

// src/organisms/Input/InputCurrency/InputCurrency.tsx
import { forwardRef as forwardRef2 } from "react";
import { DollarIcon } from "@instacart/ids-core";

// src/molecules/Input/IconInputBase/IconInputBase.tsx
import { forwardRef } from "react";
import {
  InputBase,
  internalSVGIcon,
  toolingInputStyles,
  useTheme,
  combineStyles,
  POSITION_Y_CENTER
} from "@instacart/ids-core";
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var { SVGIcon } = internalSVGIcon;
var getIconStyles = /* @__PURE__ */ __name((alignRight) => ({
  icon: __spreadValues(__spreadValues({
    position: "absolute"
  }, alignRight ? { right: 12 } : { left: 12 }), POSITION_Y_CENTER),
  iconInput: {
    position: "relative",
    width: "100%"
  }
}), "getIconStyles");
var getInputStyles = /* @__PURE__ */ __name((theme, alignRight) => __spreadProps(__spreadValues({}, toolingInputStyles(theme)), {
  input: __spreadProps(__spreadValues({}, alignRight ? { paddingRight: 36 } : { paddingLeft: 36 }), {
    "::-webkit-inner-spin-button, ::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0
    },
    '&[type="number"]': {
      MozAppearance: "textfield"
    }
  })
}), "getInputStyles");
var IconInputBase = forwardRef(
  /* @__PURE__ */ __name(function IconInputBase2(_a, ref) {
    var _b = _a, { id, component, styles, disabled, alignRight = false } = _b, rest = __objRest(_b, ["id", "component", "styles", "disabled", "alignRight"]);
    const theme = useTheme();
    const { icon, iconInput } = combineStyles(getIconStyles(alignRight), styles);
    const inputStyles = getInputStyles(theme, alignRight);
    const color = disabled ? "systemGrayscale30" : "systemGrayscale70";
    return /* @__PURE__ */ jsxs("div", { css: iconInput, children: [
      /* @__PURE__ */ jsx(
        InputBase,
        __spreadValues({
          id,
          styles: inputStyles,
          ref,
          "data-testid": "icon-input-base",
          disabled
        }, rest)
      ),
      /* @__PURE__ */ jsx(SVGIcon, { "aria-hidden": true, size: 16, component, css: icon, color })
    ] });
  }, "IconInputBase")
);
IconInputBase.displayName = "IconInputBase";

// src/organisms/Input/InputCurrency/InputCurrency.tsx
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
var InputCurrency = forwardRef2(
  /* @__PURE__ */ __name(function InputCurrency2(_a, ref) {
    var _b = _a, { id } = _b, rest = __objRest(_b, ["id"]);
    return /* @__PURE__ */ jsx2(
      IconInputBase,
      __spreadValues({
        id,
        ref,
        type: "number",
        component: /* @__PURE__ */ jsx2(DollarIcon, { "data-testid": "dollar-icon" })
      }, rest)
    );
  }, "InputCurrency")
);
InputCurrency.displayName = "InputCurrency";

// src/organisms/Input/InputPercent/InputPercent.tsx
import { forwardRef as forwardRef3 } from "react";
import { PercentIcon } from "@instacart/ids-core";
import { jsx as jsx3 } from "@emotion/react/jsx-runtime";
var InputPercent = forwardRef3(/* @__PURE__ */ __name(function InputPercent2(_a, ref) {
  var _b = _a, { id } = _b, rest = __objRest(_b, ["id"]);
  return /* @__PURE__ */ jsx3(
    IconInputBase,
    __spreadValues({
      id,
      ref,
      type: "number",
      component: /* @__PURE__ */ jsx3(PercentIcon, { "data-testid": "percent-icon" })
    }, rest)
  );
}, "InputPercent"));
InputPercent.displayName = "InputPercent";

// src/organisms/Input/InputSearch/InputSearch.tsx
import { forwardRef as forwardRef4 } from "react";
import { SearchIcon } from "@instacart/ids-core";
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
var InputSearch = forwardRef4(/* @__PURE__ */ __name(function InputPercent3(_a, ref) {
  var _b = _a, { id } = _b, rest = __objRest(_b, ["id"]);
  return /* @__PURE__ */ jsx4(
    IconInputBase,
    __spreadValues({
      id,
      ref,
      type: "text",
      component: /* @__PURE__ */ jsx4(SearchIcon, { "data-testid": "search-icon" }),
      alignRight: true
    }, rest)
  );
}, "InputPercent"));
InputSearch.displayName = "InputSearch";

// src/organisms/Input/InputText/InputText.tsx
import { forwardRef as forwardRef5 } from "react";
import {
  InputBase as InputBase2,
  toolingInputStyles as toolingInputStyles2,
  useTheme as useTheme2
} from "@instacart/ids-core";
import { jsx as jsx5 } from "@emotion/react/jsx-runtime";
var getStyles = /* @__PURE__ */ __name((theme) => toolingInputStyles2(theme), "getStyles");
var InputText = forwardRef5(/* @__PURE__ */ __name(function InputText2(props, ref) {
  const theme = useTheme2();
  const styles = getStyles(theme);
  return /* @__PURE__ */ jsx5(InputBase2, __spreadValues({ styles, ref }, props));
}, "InputText"));
InputText.displayName = "InputText";

// src/molecules/Input/InputDescriptionErrorText/InputDescriptionErrorText.tsx
import { useTheme as useTheme4 } from "@instacart/ids-core";

// src/atoms/Input/InputDescriptionBase/InputDescriptionBase.tsx
import { combineStyles as combineStyles2, spacing, useTheme as useTheme3 } from "@instacart/ids-core";
import { jsx as jsx6 } from "@emotion/react/jsx-runtime";
var getStyles2 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({
    display: "block",
    marginTop: spacing.s4
  }, theme.typography.bodyMedium2),
  disabled: {
    color: theme.colors.systemGrayscale30
  }
}), "getStyles");
var InputDescriptionBase = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    styles,
    children,
    disabled
  } = _b, rest = __objRest(_b, [
    "styles",
    "children",
    "disabled"
  ]);
  const theme = useTheme3();
  const { text, disabled: disabledStyles } = combineStyles2(getStyles2(theme), styles);
  const css = [
    text,
    {
      "&.disabled": disabledStyles
    }
  ];
  return /* @__PURE__ */ jsx6(
    "span",
    __spreadProps(__spreadValues({
      css,
      className: disabled ? "disabled" : void 0,
      "data-testid": "input-description-base"
    }, rest), {
      children
    })
  );
}, "InputDescriptionBase");
InputDescriptionBase.displayName = "InputDescriptionBase";

// src/molecules/Input/InputDescriptionErrorText/InputDescriptionErrorText.tsx
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var getStyles3 = /* @__PURE__ */ __name((theme) => ({
  text: {
    color: theme.colors.systemDetrimentalDark
  }
}), "getStyles");
var InputDescriptionErrorText = /* @__PURE__ */ __name((props) => {
  const theme = useTheme4();
  const styles = getStyles3(theme);
  return /* @__PURE__ */ jsx7(InputDescriptionBase, __spreadValues({ styles, "data-testid": "error-text" }, props));
}, "InputDescriptionErrorText");
InputDescriptionErrorText.displayName = "InputDescriptionErrorText";

// src/molecules/Input/InputDescriptionHintText/InputDescriptionHintText.tsx
import { useTheme as useTheme5 } from "@instacart/ids-core";
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var getStyles4 = /* @__PURE__ */ __name((theme) => ({
  text: {
    color: theme.colors.systemGrayscale50
  }
}), "getStyles");
var InputDescriptionHintText = /* @__PURE__ */ __name((props) => {
  const theme = useTheme5();
  const styles = getStyles4(theme);
  return /* @__PURE__ */ jsx8(InputDescriptionBase, __spreadValues({ styles, "data-testid": "hint-text" }, props));
}, "InputDescriptionHintText");
InputDescriptionHintText.displayName = "InputDescriptionHintText";

// src/molecules/Input/InputWrapper/validations.tsx
var validateInputWrapperNumber = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind } = engine;
  const inputTextIndex = flatIndexOfByKind(InputText);
  const inputPercentIndex = flatIndexOfByKind(InputPercent);
  const inputCurrencyIndex = flatIndexOfByKind(InputCurrency);
  const hintIndex = flatIndexOfByKind(InputDescriptionHintText);
  const errorIndex = flatIndexOfByKind(InputDescriptionErrorText);
  const foundInputTexts = findAllByKind(InputText);
  const foundInputPercent = findAllByKind(InputPercent);
  const foundInputCurrency = findAllByKind(InputCurrency);
  const foundHints = findAllByKind(InputDescriptionHintText);
  const foundErrors = findAllByKind(InputDescriptionErrorText);
  const inputIndicesFound = [inputTextIndex, inputPercentIndex, inputCurrencyIndex].filter(
    (i) => i > -1
  ).length;
  if (inputIndicesFound > 1 || inputIndicesFound < 1) {
    throw new CompositionXorItemsError([InputText]);
  }
  try {
    expect(foundInputTexts).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError(InputText, "one at most");
  }
  try {
    expect(foundInputPercent).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError(InputPercent, "one at most");
  }
  try {
    expect(foundInputCurrency).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError(InputCurrency, "one at most");
  }
  const descriptionIndicesFound = [hintIndex, errorIndex].filter((i) => i > -1).length;
  if (descriptionIndicesFound > 1) {
    throw new CompositionXorItemsError([InputDescriptionHintText, InputDescriptionErrorText]);
  }
  try {
    expect(foundHints).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError(InputDescriptionHintText, "one at most");
  }
  try {
    expect(foundErrors).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError(InputDescriptionErrorText, "one at most");
  }
}, "validateInputWrapperNumber");
var validateInputWrapperOrder = /* @__PURE__ */ __name((engine) => {
  const { expect, getAllChildren, flatIndexOfByKind } = engine;
  const all = getAllChildren();
  const hintIndex = flatIndexOfByKind(InputDescriptionHintText);
  const errorIndex = flatIndexOfByKind(InputDescriptionErrorText);
  if (hintIndex > -1) {
    try {
      expect(hintIndex).toEqual(1);
    } catch (e) {
      throw new CompositionOrderError(all[1], all[hintIndex]);
    }
  }
  if (errorIndex > -1) {
    try {
      expect(errorIndex).toEqual(1);
    } catch (e) {
      throw new CompositionOrderError(all[1], all[errorIndex]);
    }
  }
}, "validateInputWrapperOrder");

// src/molecules/Input/InputWrapper/InputWrapper.tsx
import { jsx as jsx9 } from "@emotion/react/jsx-runtime";
var getStyles5 = /* @__PURE__ */ __name(() => ({
  container: {
    width: "100%"
  }
}), "getStyles");
var validator = new CompositionValidator([validateInputWrapperNumber, validateInputWrapperOrder]);
var InputWrapper = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { styles, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { container } = combineStyles3(getStyles5(), styles);
  validator.validate(children);
  return /* @__PURE__ */ jsx9("span", __spreadProps(__spreadValues({ css: container }, rest), { "data-testid": "input-wrapper", children }));
}, "InputWrapper");
InputWrapper.displayName = "InputWrapper";

// src/molecules/Input/InfoInputIcon/index.ts
var InfoInputIcon_exports = {};
__export(InfoInputIcon_exports, {
  InfoInputIcon: () => InfoInputIcon
});

// src/molecules/Input/InfoInputIcon/InfoInputIcon.tsx
import { forwardRef as forwardRef6 } from "react";
import { PopoverDisclosure } from "reakit";
import {
  useTheme as useTheme6,
  combineStyles as combineStyles4,
  InformationIcon,
  useAriaLabel
} from "@instacart/ids-core";
import { jsx as jsx10 } from "@emotion/react/jsx-runtime";
var MAX_ICON_SIZE = 24;
var TRANSITION_DURATION_MS = 200;
var getStyles6 = /* @__PURE__ */ __name((theme) => ({
  disclosure: {
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    touchAction: "manipulation",
    position: "relative",
    backgroundColor: "transparent",
    marginLeft: 10,
    height: 38,
    width: 24,
    flexGrow: 0
  },
  focusRing: {
    border: `2px solid ${theme.colors.systemGrayscale70}`,
    width: MAX_ICON_SIZE + 4,
    height: MAX_ICON_SIZE + 4,
    borderRadius: "50%",
    content: '""',
    display: "block",
    position: "absolute",
    top: 2,
    left: -4
  },
  icon: {
    transition: `all ${TRANSITION_DURATION_MS}ms ease-in-out`
  },
  iconHover: {
    fill: theme.colors.systemGrayscale50
  },
  hover: {},
  active: {},
  disabled: {
    cursor: "default"
  }
}), "getStyles");
var InfoInputIcon = forwardRef6(
  /* @__PURE__ */ __name(function InfoInputIcon2(_a, ref) {
    var _b = _a, { styles, description, popover } = _b, rest = __objRest(_b, ["styles", "description", "popover"]);
    const theme = useTheme6();
    const { icon, iconHover, disclosure, focusRing, active, disabled, hover } = combineStyles4(
      getStyles6(theme),
      styles
    );
    const disclosureCss = [
      disclosure,
      {
        "&:focus": {
          outline: "none"
        },
        "&.focus-visible::after": focusRing,
        "&:hover": hover,
        "&:hover svg": iconHover,
        "&:active:not(:disabled)": active,
        "&:disabled": disabled
      }
    ];
    const svgCss = [icon, { "&:hover": iconHover }];
    const ariaLabel = useAriaLabel({ description });
    return /* @__PURE__ */ jsx10(PopoverDisclosure, __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, ariaLabel), { ref, css: disclosureCss }), popover), rest), { children: /* @__PURE__ */ jsx10(
      InformationIcon,
      {
        size: MAX_ICON_SIZE,
        color: "systemGrayscale30",
        css: svgCss,
        "data-testid": "input-info-icon"
      }
    ) }));
  }, "InfoInputIcon")
);
InfoInputIcon.displayName = "InfoInputIcon";

// src/atoms/Input/LabelBase/LabelBase.tsx
import { useTheme as useTheme7, combineStyles as combineStyles5, spacing as spacing2 } from "@instacart/ids-core";
import { jsx as jsx11, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var DEFAULT_OPTIONAL_TEXT = "optional";
var LABEL_WIDTH = 144;
var getStyles7 = /* @__PURE__ */ __name((theme) => ({
  label: __spreadValues({
    color: theme.colors.systemGrayscale70,
    textAlign: "right",
    marginRight: spacing2.s12,
    width: LABEL_WIDTH,
    flexShrink: 0,
    display: "flex",
    height: "38px",
    alignItems: "center",
    justifyContent: "flex-end"
  }, theme.typography.bodyMedium1),
  content: {},
  optional: __spreadValues({}, theme.typography.bodyMedium2),
  disabled: {
    color: theme.colors.systemGrayscale30
  }
}), "getStyles");
var LabelBase = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    styles,
    children,
    isOptional = false,
    optionalText = DEFAULT_OPTIONAL_TEXT,
    htmlFor,
    disabled
  } = _b, rest = __objRest(_b, [
    "styles",
    "children",
    "isOptional",
    "optionalText",
    "htmlFor",
    "disabled"
  ]);
  const theme = useTheme7();
  const {
    label,
    content,
    optional,
    disabled: disabledStyles
  } = combineStyles5(getStyles7(theme), styles);
  const css = [
    label,
    {
      "&.disabled": disabledStyles
    }
  ];
  const optionalString = optionalText && ` (${optionalText.trim()})`;
  return /* @__PURE__ */ jsx11(
    "label",
    __spreadProps(__spreadValues({
      css,
      htmlFor,
      className: disabled ? "disabled" : void 0,
      "data-testid": "label-base"
    }, rest), {
      children: /* @__PURE__ */ jsxs2("span", { css: content, children: [
        children,
        isOptional ? /* @__PURE__ */ jsx11("span", { css: optional, children: optionalString }) : null
      ] })
    })
  );
}, "LabelBase");

// src/molecules/Input/Label/Label.tsx
import { jsx as jsx12 } from "@emotion/react/jsx-runtime";
var Label = /* @__PURE__ */ __name((props) => {
  return /* @__PURE__ */ jsx12(LabelBase, __spreadValues({}, props));
}, "Label");
Label.displayName = "Label";

// src/atoms/Input/FieldBase/validations.tsx
var { Coachmark } = unstableCoachmark;
var validateFieldBase = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind, getAll } = engine;
  const all = getAll();
  const wrapperIndex = flatIndexOfByKind(InputWrapper);
  const iconIndex = flatIndexOfByKind(InfoInputIcon);
  const coachmarkIndex = flatIndexOfByKind(Coachmark);
  const labelIndex = flatIndexOfByKind(Label);
  const foundWrappers = findAllByKind(InputWrapper);
  const foundIcons = findAllByKind(InfoInputIcon);
  const foundCoachmarks = findAllByKind(Coachmark);
  const foundLabels = findAllByKind(Label);
  try {
    expect(foundLabels).toHaveLength(1);
  } catch (e) {
    if (foundLabels.length > 1) {
      throw new CompositionTooManyItemsError2(Label, "one at most");
    } else if (foundLabels.length < 1) {
      throw new CompositionTooFewItemsError(Label, "one at most");
    }
  }
  try {
    expect(foundWrappers).toHaveLength(1);
  } catch (e) {
    if (foundWrappers.length > 1) {
      throw new CompositionTooManyItemsError2(InputWrapper, "one at most");
    } else if (foundWrappers.length < 1) {
      throw new CompositionTooFewItemsError(InputWrapper, "one at most");
    }
  }
  try {
    expect(foundIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError2(InfoInputIcon, "one at most");
  }
  try {
    expect(foundCoachmarks).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError2(Coachmark, "one at most");
  }
  const indicesFound = [iconIndex, coachmarkIndex].filter((i) => i > -1).length;
  if (iconIndex > -1 || coachmarkIndex > -1) {
    try {
      expect(indicesFound).toEqual(2);
    } catch (e) {
      if (iconIndex < 0) {
        throw new CompositionTooFewItemsError(InfoInputIcon, "exactly one");
      } else if (coachmarkIndex < 0) {
        throw new CompositionTooFewItemsError(Coachmark, "exactly one");
      }
    }
  }
  if (labelIndex > -1 && wrapperIndex > -1) {
    try {
      expect(labelIndex).toBeLessThan(wrapperIndex);
    } catch (e) {
      throw new CompositionOrderError2(all[labelIndex], all[wrapperIndex]);
    }
  }
  if (wrapperIndex > -1 && iconIndex > -1) {
    try {
      expect(wrapperIndex).toBeLessThan(iconIndex);
    } catch (e) {
      throw new CompositionOrderError2(all[wrapperIndex], all[iconIndex]);
    }
  }
}, "validateFieldBase");

// src/atoms/Input/FieldBase/FieldBase.tsx
import { jsx as jsx13 } from "@emotion/react/jsx-runtime";
var getStyles8 = /* @__PURE__ */ __name(() => ({
  field: {
    display: "flex",
    padding: `${spacing3.s12}px 0px`
  }
}), "getStyles");
var validator2 = new CompositionValidator2([validateFieldBase]);
var FieldBase = forwardRef7(/* @__PURE__ */ __name(function FieldBase2(_a, ref) {
  var _b = _a, { styles, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { field } = combineStyles6(getStyles8(), styles);
  validator2.validate(children);
  return /* @__PURE__ */ jsx13("div", __spreadProps(__spreadValues({ css: field, ref }, rest), { children }));
}, "FieldBase"));
FieldBase.displayName = "FieldBase";

// src/atoms/Table/CellButtonBase/CellButtonBase.tsx
import { forwardRef as forwardRef8 } from "react";
import { spacing as spacing4, ButtonBase, useTheme as useTheme8 } from "@instacart/ids-core";
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
var ACTION_HEIGHT = 32;
var OPTICAL_ALIGNED_PADDING_TOP = 6;
var getStyles9 = /* @__PURE__ */ __name((theme) => ({
  button: __spreadValues({
    height: ACTION_HEIGHT,
    padding: `${OPTICAL_ALIGNED_PADDING_TOP}px ${spacing4.s12}px ${spacing4.s8}px`,
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale70,
    borderRadius: theme.radius.r8
  }, theme.typography.bodySmall1),
  active: {
    backgroundColor: theme.colors.systemGrayscale20
  },
  focusRing: {
    borderRadius: theme.radius.r8
  },
  disabled: {
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale30,
    cursor: "not-allowed"
  },
  loading: {
    backgroundColor: theme.colors.systemGrayscale20
  }
}), "getStyles");
var CellButtonBase = forwardRef8(
  /* @__PURE__ */ __name(function CellButtonBase2(_a, ref) {
    var rest = __objRest(_a, []);
    const theme = useTheme8();
    const styles = getStyles9(theme);
    return /* @__PURE__ */ jsx14(ButtonBase, __spreadProps(__spreadValues({}, rest), { styles, ref, type: "button" }));
  }, "CellButtonBase")
);
CellButtonBase.displayName = "CellButtonBase";

// src/atoms/Table/CellImageBase/CellImageBase.tsx
import { combineStyles as combineStyles7, spacing as spacing5 } from "@instacart/ids-core";
import { jsx as jsx15 } from "@emotion/react/jsx-runtime";
var getStyles10 = /* @__PURE__ */ __name(() => ({
  image: {
    display: "block",
    width: spacing5.s24,
    height: spacing5.s24
  }
}), "getStyles");
var CellImageBase = /* @__PURE__ */ __name((props) => {
  const _a = props, { alt, styles } = _a, rest = __objRest(_a, ["alt", "styles"]);
  const { image } = combineStyles7(getStyles10(), styles);
  return /* @__PURE__ */ jsx15("img", __spreadProps(__spreadValues({}, rest), { alt, css: image }));
}, "CellImageBase");
CellImageBase.displayName = "CellImageBase";

// src/atoms/Table/CellBase/CellBase.tsx
import { combineStyles as combineStyles8, useTheme as useTheme9, spacing as spacing6 } from "@instacart/ids-core";

// src/atoms/Table/CellBase/types.ts
var Align = /* @__PURE__ */ ((Align3) => {
  Align3["LEFT"] = "left";
  Align3["RIGHT"] = "right";
  return Align3;
})(Align || {});

// src/atoms/Table/CellBase/CellBase.tsx
import { jsx as jsx16 } from "@emotion/react/jsx-runtime";
var MAX_WIDTH_PX = 384;
var HEIGHT_PX = 38;
var getAlignmentStyles = /* @__PURE__ */ __name((alignment) => {
  switch (alignment) {
    case "right" /* RIGHT */:
      return {
        paddingLeft: `${spacing6.s8}px`,
        justifyContent: "flex-end",
        textAlign: "right" /* RIGHT */
      };
    case "left" /* LEFT */:
    default:
      return {
        textAlign: "left" /* LEFT */
      };
  }
}, "getAlignmentStyles");
var getStyles11 = /* @__PURE__ */ __name((theme, alignment, gutterPx) => ({
  cell: __spreadValues({
    maxWidth: MAX_WIDTH_PX,
    height: HEIGHT_PX,
    backgroundColor: theme.colors.systemGrayscale00,
    color: theme.colors.systemGrayscale70,
    boxShadow: `inset 0px 1px 0px ${theme.colors.systemGrayscale10}`
  }, theme.typography.bodyMedium2),
  content: __spreadProps(__spreadValues({
    display: "flex",
    alignItems: "center",
    padding: `7px ${spacing6.s16}px 9px 0px`
  }, getAlignmentStyles(alignment)), {
    "&": {
      marginLeft: `-${gutterPx}px`
    },
    "& > *": {
      // Necessary blunt tool: Using !important flag to override any potential specificity issues
      // e.g., ButtonBase explicitly sets margin: 0; and clashes w/ this rule as a result
      marginLeft: `${gutterPx}px !important`
    }
  })
}), "getStyles");
var CellBase = /* @__PURE__ */ __name((_a) => {
  var _b = _a, {
    styles,
    overrideAsHeader,
    alignment = "left" /* LEFT */,
    gutterPx = spacing6.s8,
    children
  } = _b, rest = __objRest(_b, [
    "styles",
    "overrideAsHeader",
    "alignment",
    "gutterPx",
    "children"
  ]);
  const theme = useTheme9();
  const El = overrideAsHeader ? "th" : "td";
  const { cell, content } = combineStyles8(getStyles11(theme, alignment, gutterPx), styles);
  const scope = overrideAsHeader ? { scope: "row" } : {};
  return /* @__PURE__ */ jsx16(El, __spreadProps(__spreadValues(__spreadValues({ css: cell }, scope), rest), { children: /* @__PURE__ */ jsx16("div", { css: content, "data-testid": "table-cell-base-content", children }) }));
}, "CellBase");
CellBase.displayName = "CellBase";

// src/atoms/Table/HeaderCellBase/HeaderCellBase.tsx
import { forwardRef as forwardRef11 } from "react";
import {
  ButtonBase as ButtonBase2,
  combineStyles as combineStyles12,
  CompositionValidator as CompositionValidator4,
  spacing as spacing9,
  useTheme as useTheme12,
  useAriaLabel as useAriaLabel3
} from "@instacart/ids-core";

// src/atoms/Table/HeaderCellBase/validations.tsx
import {
  CompositionOrderError as CompositionOrderError3,
  CompositionTooManyItemsError as CompositionTooManyItemsError4,
  CompositionTooFewItemsError as CompositionTooFewItemsError3,
  CompositionXorItemsError as CompositionXorItemsError2
} from "@instacart/ids-core";

// src/organisms/Table/Cells/HeaderCell/HeaderCheckbox/HeaderCheckbox.tsx
import { forwardRef as forwardRef9 } from "react";
import {
  CheckboxBase
} from "@instacart/ids-core";
import { jsx as jsx17 } from "@emotion/react/jsx-runtime";
var getStyles12 = /* @__PURE__ */ __name(() => ({
  container: {
    marginTop: "-3px",
    marginBottom: "-3px",
    marginRight: 0
  }
}), "getStyles");
var HeaderCheckbox = forwardRef9(
  /* @__PURE__ */ __name(function HeaderCheckbox2(props, ref) {
    const styles = getStyles12();
    return /* @__PURE__ */ jsx17(CheckboxBase, __spreadProps(__spreadValues({}, props), { styles, ref }));
  }, "HeaderCheckbox")
);
HeaderCheckbox.displayName = "HeaderCheckbox";

// src/molecules/Table/Cells/CellIcon/CellIcon.tsx
import { useAriaLabel as useAriaLabel2, internalSVGIcon as internalSVGIcon2 } from "@instacart/ids-core";
import { jsx as jsx18 } from "@emotion/react/jsx-runtime";
var { SVGIcon: SVGIcon2 } = internalSVGIcon2;
var MAX_ICON_SIZE2 = 24;
var getStyles13 = /* @__PURE__ */ __name(() => ({
  icon: {
    marginRight: "-2px",
    flexShrink: 0
  }
}), "getStyles");
var CellIcon = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { alt, labelledBy } = _b, rest = __objRest(_b, ["alt", "labelledBy"]);
  const describedBy = useAriaLabel2({ description: alt, relatedIds: labelledBy });
  const { icon } = getStyles13();
  return /* @__PURE__ */ jsx18(SVGIcon2, __spreadProps(__spreadValues(__spreadValues({ size: MAX_ICON_SIZE2, "data-testid": "cell-icon" }, rest), describedBy), { css: icon }));
}, "CellIcon");
CellIcon.displayName = "CellIcon";

// src/organisms/Table/Cells/HeaderCell/HeaderIcon/HeaderIcon.tsx
import { jsx as jsx19 } from "@emotion/react/jsx-runtime";
var getStyles14 = /* @__PURE__ */ __name(() => ({
  icon: {
    margin: "-3px 0"
  }
}), "getStyles");
var HeaderIcon = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { alt } = _b, rest = __objRest(_b, ["alt"]);
  const { icon } = getStyles14();
  return /* @__PURE__ */ jsx19(CellIcon, __spreadValues({ css: icon, alt }, rest));
}, "HeaderIcon");

// src/organisms/Table/Cells/HeaderCell/HeaderSubtitle/HeaderSubtitle.tsx
import { useTheme as useTheme10 } from "@instacart/ids-core";

// src/molecules/Table/Cells/CellText/CellText.tsx
import { combineStyles as combineStyles9 } from "@instacart/ids-core";
import { jsx as jsx20 } from "@emotion/react/jsx-runtime";
var MAX_WIDTH_PX2 = 340;
var getStyles15 = /* @__PURE__ */ __name(() => ({
  text: {
    display: "block",
    maxWidth: MAX_WIDTH_PX2,
    textOverflow: "ellipsis",
    overflowX: "hidden"
  }
}), "getStyles");
var CellText = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { styles, children } = _b, rest = __objRest(_b, ["styles", "children"]);
  const { text } = combineStyles9(getStyles15(), styles);
  return /* @__PURE__ */ jsx20("span", __spreadProps(__spreadValues({ css: text, "data-testid": "cell-text" }, rest), { children }));
}, "CellText");
CellText.displayName = "CellText";

// src/organisms/Table/Cells/HeaderCell/HeaderSubtitle/HeaderSubtitle.tsx
import { jsx as jsx21 } from "@emotion/react/jsx-runtime";
var getTextStyles = /* @__PURE__ */ __name((theme) => ({
  text: __spreadValues({}, theme.typography.bodySmall2)
}), "getTextStyles");
var HeaderSubtitle = /* @__PURE__ */ __name(({ children }) => {
  const theme = useTheme10();
  const textStyles = getTextStyles(theme);
  return /* @__PURE__ */ jsx21(CellText, { styles: textStyles, children });
}, "HeaderSubtitle");
HeaderSubtitle.displayName = "HeaderSubtitle";

// src/organisms/Table/Cells/HeaderCell/HeaderTitle/HeaderTitle.tsx
import { forwardRef as forwardRef10 } from "react";
import { combineStyles as combineStyles11, CompositionValidator as CompositionValidator3, spacing as spacing8 } from "@instacart/ids-core";

// src/organisms/Table/Cells/HeaderCell/HeaderTitle/HeaderTitleValidations.tsx
import {
  CompositionTooManyItemsError as CompositionTooManyItemsError3,
  CompositionTooFewItemsError as CompositionTooFewItemsError2,
  CompositionInvalidChildError,
  CompositionEngineItemType
} from "@instacart/ids-core";

// src/organisms/Table/Cells/HeaderCell/HeaderTitleText/HeaderTitleText.tsx
import { useTheme as useTheme11 } from "@instacart/ids-core";
import { jsx as jsx22 } from "@emotion/react/jsx-runtime";
var getTextStyles2 = /* @__PURE__ */ __name((theme) => ({
  text: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
    maxWidth: "320px"
  })
}), "getTextStyles");
var HeaderTitleText = /* @__PURE__ */ __name((props) => {
  const theme = useTheme11();
  const textStyles = getTextStyles2(theme);
  return /* @__PURE__ */ jsx22(CellText, __spreadValues({ styles: textStyles }, props));
}, "HeaderTitleText");
HeaderTitleText.displayName = "HeaderTitleText";

// src/organisms/Table/Cells/HeaderCell/HeaderSortIcon/HeaderSortIcon.tsx
import {
  ArrowDownIcon,
  ArrowUpIcon,
  combineStyles as combineStyles10,
  spacing as spacing7,
  internalSVGIcon as internalSVGIcon3
} from "@instacart/ids-core";
import { jsx as jsx23 } from "@emotion/react/jsx-runtime";
var { SVGIcon: SVGIcon3 } = internalSVGIcon3;
var ICON_SIZE = `${spacing7.s16}px`;
var SortState = /* @__PURE__ */ ((SortState3) => {
  SortState3["ASC"] = "ascending";
  SortState3["DESC"] = "descending";
  SortState3["DEFAULT"] = "default";
  return SortState3;
})(SortState || {});
var getStyles16 = /* @__PURE__ */ __name((sortState) => ({
  icon: {
    visibility: sortState === "default" /* DEFAULT */ ? "hidden" : "visible"
  }
}), "getStyles");
var HeaderSortIcon = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { sortState, styles } = _b, rest = __objRest(_b, ["sortState", "styles"]);
  const { icon } = combineStyles10(getStyles16(sortState), styles);
  const El = sortState === "ascending" /* ASC */ ? ArrowUpIcon : ArrowDownIcon;
  const testId = `sort-icon${sortState ? `-${sortState}` : ""}`;
  return /* @__PURE__ */ jsx23(
    SVGIcon3,
    __spreadValues({
      "aria-hidden": true,
      component: /* @__PURE__ */ jsx23(El, { size: ICON_SIZE }),
      "data-testid": testId,
      css: icon
    }, rest)
  );
}, "HeaderSortIcon");

// src/organisms/Table/Cells/HeaderCell/HeaderTitle/HeaderTitleValidations.tsx
var validateHeaderTitle = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind, childIndexOfByItemType, getAllChildren } = engine;
  const all = getAllChildren();
  const unwrappedTextIndex = childIndexOfByItemType(CompositionEngineItemType.TextContent);
  const subTitleIndex = flatIndexOfByKind(HeaderSubtitle);
  const sortIconIndex = flatIndexOfByKind(HeaderSortIcon);
  const iconIndex = flatIndexOfByKind(HeaderIcon);
  const checkboxIndex = flatIndexOfByKind(HeaderCheckbox);
  const foundTextTitles = findAllByKind(HeaderTitleText);
  try {
    expect(foundTextTitles).toHaveLength(1);
  } catch (e) {
    const addtl = "exactly one";
    if (foundTextTitles.length > 1) {
      throw new CompositionTooManyItemsError3(HeaderTitleText, addtl);
    } else {
      throw new CompositionTooFewItemsError2(HeaderTitleText, addtl);
    }
  }
  if (unwrappedTextIndex > -1) {
    throw new CompositionInvalidChildError(
      all[unwrappedTextIndex],
      "text must be wrapped in HeaderTitleText or HeaderSubtitleText"
    );
  }
  if (sortIconIndex > -1) {
    throw new CompositionInvalidChildError(
      all[sortIconIndex],
      "sort is handled internally by HeaderTitle via a sortState prop, please do not provide HeaderSortIcon directly"
    );
  }
  if (iconIndex > -1) {
    throw new CompositionTooManyItemsError3(HeaderIcon, "exactly zero");
  }
  if (checkboxIndex > -1) {
    throw new CompositionTooManyItemsError3(HeaderCheckbox, "exactly zero");
  }
  if (subTitleIndex > -1) {
    throw new CompositionTooManyItemsError3(HeaderSubtitle, "exactly zero");
  }
}, "validateHeaderTitle");

// src/organisms/Table/Cells/HeaderCell/HeaderTitle/HeaderTitle.tsx
import { jsx as jsx24, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var getAlignmentStyles2 = /* @__PURE__ */ __name((alignment) => alignment === "right" /* RIGHT */ ? { container: { flexDirection: "row-reverse" } } : {}, "getAlignmentStyles");
var getStyles17 = /* @__PURE__ */ __name(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    "&": {
      marginLeft: `-${spacing8.s8}px`
    },
    "& > *": {
      marginLeft: spacing8.s8
    }
  }
}), "getStyles");
var validator3 = new CompositionValidator3([validateHeaderTitle]);
var HeaderTitle = forwardRef10(/* @__PURE__ */ __name(function HeaderTitle2(_a, ref) {
  var _b = _a, { styles, alignment = "left" /* LEFT */, children, sortState } = _b, rest = __objRest(_b, ["styles", "alignment", "children", "sortState"]);
  const additionalStyles = __spreadValues(__spreadValues({}, getAlignmentStyles2(alignment)), styles);
  const { container } = combineStyles11(getStyles17(), additionalStyles);
  validator3.validate(children);
  return /* @__PURE__ */ jsxs3("div", __spreadProps(__spreadValues({ css: container }, rest), { ref, "data-testid": "header-title", children: [
    children,
    sortState && /* @__PURE__ */ jsx24(HeaderSortIcon, { sortState })
  ] }));
}, "HeaderTitle"));
HeaderTitle.displayName = "HeaderTitle";

// src/atoms/Table/HeaderCellBase/validations.tsx
var validateHeaderCellBaseNumber = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind, getAllChildren } = engine;
  const all = getAllChildren();
  const titleIndex = flatIndexOfByKind(HeaderTitle);
  const subTitleIndex = flatIndexOfByKind(HeaderSubtitle);
  const iconIndex = flatIndexOfByKind(HeaderIcon);
  const checkboxIndex = flatIndexOfByKind(HeaderCheckbox);
  const foundTitles = findAllByKind(HeaderTitle);
  const foundSubtitles = findAllByKind(HeaderSubtitle);
  const foundIcons = findAllByKind(HeaderIcon);
  const foundCheckboxes = findAllByKind(HeaderCheckbox);
  const indicesFound = [titleIndex, iconIndex, checkboxIndex].filter((i) => i > -1).length;
  if (indicesFound > 1) {
    throw new CompositionXorItemsError2([HeaderTitle, HeaderIcon, HeaderCheckbox]);
  }
  try {
    expect(foundTitles).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError4(HeaderTitle, "one at most");
  }
  try {
    expect(foundSubtitles).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError4(HeaderSubtitle, "one at most");
  }
  try {
    expect(foundIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError4(HeaderIcon, "one at most");
  }
  try {
    expect(foundCheckboxes).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError4(HeaderCheckbox, "one at most");
  }
  if (subTitleIndex > -1 && titleIndex < 0) {
    throw new CompositionTooFewItemsError3(HeaderTitle, "exactly one");
  }
  if (iconIndex > -1 && all.length > 1) {
    throw new CompositionTooManyItemsError4(HeaderIcon, "exactly zero siblings");
  }
  if (iconIndex > -1 && all.length > 1) {
    throw new CompositionTooManyItemsError4(HeaderCheckbox, "exactly zero siblings");
  }
}, "validateHeaderCellBaseNumber");
var validateHeaderCellBaseOrder = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind } = engine;
  const all = getAll();
  const titleIndex = flatIndexOfByKind(HeaderTitle);
  const subTitleIndex = flatIndexOfByKind(HeaderSubtitle);
  if (titleIndex > -1 && subTitleIndex > -1) {
    try {
      expect(titleIndex).toBeLessThan(subTitleIndex);
    } catch (e) {
      throw new CompositionOrderError3(all[titleIndex], all[subTitleIndex]);
    }
  }
}, "validateHeaderCellBaseOrder");

// src/atoms/Table/HeaderCellBase/HeaderCellBase.tsx
import { jsx as jsx25 } from "@emotion/react/jsx-runtime";
var MAX_WIDTH_PX3 = 384;
var MIN_HEIGHT_PX = 44;
var getAlignmentStyles3 = /* @__PURE__ */ __name((alignment) => {
  switch (alignment) {
    case "right" /* RIGHT */:
      return {
        paddingLeft: `${spacing9.s16}px`,
        textAlign: "right" /* RIGHT */
      };
    case "left" /* LEFT */:
    default:
      return {
        textAlign: "left" /* LEFT */
      };
  }
}, "getAlignmentStyles");
var getContainerStyles = /* @__PURE__ */ __name((theme, alignment) => ({
  margin: "11px 0 13px",
  backgroundColor: theme.colors.systemGrayscale00,
  color: theme.colors.systemGrayscale70,
  textAlign: alignment,
  width: "100%"
}), "getContainerStyles");
var getStyles18 = /* @__PURE__ */ __name((theme, alignment) => ({
  cell: __spreadValues({
    maxWidth: MAX_WIDTH_PX3,
    height: MIN_HEIGHT_PX,
    backgroundColor: theme.colors.systemGrayscale00,
    color: theme.colors.systemGrayscale70,
    boxShadow: `inset 0px 1px 0px ${theme.colors.systemGrayscale20}`,
    padding: `0px ${spacing9.s16}px 0px 0px`
  }, getAlignmentStyles3(alignment)),
  container: getContainerStyles(theme, alignment)
}), "getStyles");
var getButtonStyles = /* @__PURE__ */ __name((theme, alignment) => ({ button: getContainerStyles(theme, alignment) }), "getButtonStyles");
var validator4 = new CompositionValidator4([
  validateHeaderCellBaseNumber,
  validateHeaderCellBaseOrder
]);
var HeaderCellBase = forwardRef11(
  /* @__PURE__ */ __name(function HeaderCellBase2(_a, ref) {
    var _b = _a, { styles, alignment = "left" /* LEFT */, onClick, description, children } = _b, rest = __objRest(_b, ["styles", "alignment", "onClick", "description", "children"]);
    const theme = useTheme12();
    const { cell, container } = combineStyles12(getStyles18(theme, alignment), styles);
    const buttonStyles = getButtonStyles(theme, alignment);
    const ariaLabel = useAriaLabel3({ description });
    const elem = onClick ? /* @__PURE__ */ jsx25(ButtonBase2, { ref, styles: buttonStyles, onClick, children }) : /* @__PURE__ */ jsx25("div", { css: container, children });
    validator4.validate(children);
    return /* @__PURE__ */ jsx25("th", __spreadProps(__spreadValues(__spreadValues({ css: cell, scope: "col" }, ariaLabel), rest), { children: elem }));
  }, "HeaderCellBase")
);
HeaderCellBase.displayName = "HeaderCellBase";

// src/atoms/IconButtonBase/IconButtonBase.tsx
import { forwardRef as forwardRef12 } from "react";
import {
  ButtonBase as ButtonBase3,
  useTheme as useTheme13,
  combineStyles as combineStyles13
} from "@instacart/ids-core";
import { jsx as jsx26 } from "@emotion/react/jsx-runtime";
var getStyles19 = /* @__PURE__ */ __name((theme) => ({
  button: {
    backgroundColor: theme.colors.systemGrayscale10,
    borderRadius: theme.radius.r8
  },
  content: {},
  hover: {},
  active: {},
  disabled: {},
  focusRing: {}
}), "getStyles");
var IconButtonBase = forwardRef12(
  /* @__PURE__ */ __name(function IconButtonBase2(_a, ref) {
    var _b = _a, { icon: Icon, color, disabled, accessibleLabel, overrideStyles = {} } = _b, props = __objRest(_b, ["icon", "color", "disabled", "accessibleLabel", "overrideStyles"]);
    const theme = useTheme13();
    const baseStyles = getStyles19(theme);
    const styles = overrideStyles ? combineStyles13(baseStyles, overrideStyles) : baseStyles;
    return /* @__PURE__ */ jsx26(
      ButtonBase3,
      __spreadProps(__spreadValues({
        "aria-label": accessibleLabel
      }, props), {
        styles,
        ref,
        children: /* @__PURE__ */ jsx26(Icon, { color: disabled ? "systemGrayscale30" : color, size: 20 })
      })
    );
  }, "IconButtonBase")
);

// src/internal/TableWrapper.tsx
import { jsx as jsx27 } from "@emotion/react/jsx-runtime";
var TableWrapper = /* @__PURE__ */ __name(({
  children,
  styles
}) => /* @__PURE__ */ jsx27("table", { css: styles, children: /* @__PURE__ */ jsx27("tbody", { children: /* @__PURE__ */ jsx27("tr", { children }) }) }), "TableWrapper");

// src/molecules/IconButton/IconButton.tsx
import { forwardRef as forwardRef13 } from "react";

// src/molecules/utils/useButtonStyles.ts
import { blendColors, spacing as spacing10, useTheme as useTheme14 } from "@instacart/ids-core";
function useButtonStyles({
  primaryColor,
  activeColor,
  textColor
}) {
  const theme = useTheme14();
  return {
    button: {
      backgroundColor: theme.colors[primaryColor],
      color: theme.colors[textColor],
      borderRadius: theme.radius.r8,
      padding: `${spacing10.s8}px ${spacing10.s12}px`,
      minWidth: 166,
      height: 40
    },
    content: __spreadValues({}, theme.typography.bodyMedium1),
    focusRing: {
      borderRadius: theme.radius.r8
    },
    hover: {
      backgroundColor: blendColors(theme.colors[primaryColor], theme.colors[activeColor], 51)
    },
    active: {
      backgroundColor: theme.colors[activeColor]
    },
    disabled: {
      backgroundColor: theme.colors.systemGrayscale10,
      color: theme.colors.systemGrayscale30
    },
    loading: {
      backgroundColor: theme.colors[activeColor]
    }
  };
}
__name(useButtonStyles, "useButtonStyles");

// src/molecules/IconButton/IconButton.tsx
import { jsx as jsx28 } from "@emotion/react/jsx-runtime";
function useStyles() {
  const styles = useButtonStyles({
    primaryColor: "systemGrayscale10",
    activeColor: "systemGrayscale20",
    textColor: "systemGrayscale00"
  });
  return __spreadProps(__spreadValues({}, styles), {
    button: {
      padding: 0,
      width: 40,
      height: 40,
      minWidth: "unset",
      lineHeight: 1
    },
    content: {}
  });
}
__name(useStyles, "useStyles");
var IconButton = forwardRef13(/* @__PURE__ */ __name(function IconButton2(props, ref) {
  const styles = useStyles();
  return /* @__PURE__ */ jsx28(IconButtonBase, __spreadProps(__spreadValues({}, props), { overrideStyles: styles, ref }));
}, "IconButton"));

// src/molecules/Input/Field/Field.tsx
import { forwardRef as forwardRef14 } from "react";
import { jsx as jsx29 } from "@emotion/react/jsx-runtime";
var Field = forwardRef14(/* @__PURE__ */ __name(function Field2(props, ref) {
  return /* @__PURE__ */ jsx29(FieldBase, __spreadProps(__spreadValues({}, props), { ref }));
}, "Field"));
Field.displayName = "Field";

// src/molecules/PrimaryButton/PrimaryButton.tsx
import { forwardRef as forwardRef15 } from "react";
import { ButtonBase as ButtonBase5 } from "@instacart/ids-core";
import { jsx as jsx30 } from "@emotion/react/jsx-runtime";
var PrimaryButton = forwardRef15(
  /* @__PURE__ */ __name(function PrimaryButton2(props, ref) {
    const styles = useButtonStyles({
      primaryColor: "brandPrimaryRegular",
      activeColor: "brandPrimaryDark",
      textColor: "systemGrayscale00"
    });
    return /* @__PURE__ */ jsx30(ButtonBase5, __spreadProps(__spreadValues({}, props), { styles, ref }));
  }, "PrimaryButton")
);

// src/molecules/SecondaryButton/SecondaryButton.tsx
import { forwardRef as forwardRef16 } from "react";
import { ButtonBase as ButtonBase6 } from "@instacart/ids-core";
import { jsx as jsx31 } from "@emotion/react/jsx-runtime";
var SecondaryButton = forwardRef16(
  /* @__PURE__ */ __name(function SecondaryButton2(props, ref) {
    const styles = useButtonStyles({
      primaryColor: "systemGrayscale10",
      activeColor: "systemGrayscale20",
      textColor: "systemGrayscale70"
    });
    return /* @__PURE__ */ jsx31(ButtonBase6, __spreadProps(__spreadValues({}, props), { styles, ref }));
  }, "SecondaryButton")
);

// src/organisms/Table/Cells/ActionCell/ActionCell.tsx
import { spacing as spacing11, CompositionValidator as CompositionValidator5 } from "@instacart/ids-core";

// src/organisms/Table/Cells/ActionCell/validations.ts
import {
  CompositionTooManyItemsError as CompositionTooManyItemsError5,
  CompositionOrderError as CompositionOrderError4
} from "@instacart/ids-core";

// src/organisms/Table/Cells/ActionCell/CellButton/CellButton.tsx
import { forwardRef as forwardRef17 } from "react";
import { jsx as jsx32 } from "@emotion/react/jsx-runtime";
var CellButton = forwardRef17(/* @__PURE__ */ __name(function CellButton2(props, ref) {
  return /* @__PURE__ */ jsx32(CellButtonBase, __spreadProps(__spreadValues({}, props), { ref }));
}, "CellButton"));
CellButton.displayName = "CellButton";

// src/organisms/Table/Cells/ActionCell/CellOverflowButton/CellOverflowButton.tsx
import { forwardRef as forwardRef18 } from "react";
import {
  OptionsIcon,
  SheetDropdownDisclosureBase,
  useAriaLabel as useAriaLabel4,
  useTheme as useTheme15
} from "@instacart/ids-core";
import { jsx as jsx33 } from "@emotion/react/jsx-runtime";
var getStyles20 = /* @__PURE__ */ __name((theme) => ({
  button: {
    height: 32,
    padding: `8px 12px`,
    backgroundColor: theme.colors.systemGrayscale10,
    color: theme.colors.systemGrayscale70,
    borderRadius: theme.radius.r8
  },
  focusRing: {
    borderRadius: theme.radius.r8
  }
}), "getStyles");
var CellOverflowButton = forwardRef18(
  /* @__PURE__ */ __name(function CellOverflowButton2(_a, ref) {
    var _b = _a, { description } = _b, rest = __objRest(_b, ["description"]);
    const theme = useTheme15();
    const styles = getStyles20(theme);
    const ariaLabel = useAriaLabel4({ description });
    return /* @__PURE__ */ jsx33(SheetDropdownDisclosureBase, __spreadProps(__spreadValues(__spreadValues({ styles }, rest), ariaLabel), { ref, children: /* @__PURE__ */ jsx33(OptionsIcon, { size: 16 }) }));
  }, "CellOverflowButton")
);
CellOverflowButton.displayName = "CellOverflowButton";

// src/organisms/Table/Cells/ActionCell/validations.ts
var validateActionCell = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, findAllByKind, flatIndexOfByKind, flatLastIndexOfByKind } = engine;
  const all = getAll();
  const buttonIndex = flatIndexOfByKind(CellButton);
  const overflowIndex = flatLastIndexOfByKind(CellOverflowButton);
  const foundButtons = findAllByKind(CellButton);
  if (buttonIndex > -1) {
    try {
      expect(foundButtons).toHaveMaxLength(2);
    } catch (e) {
      throw new CompositionTooManyItemsError5(CellButton, "two at most");
    }
  }
  if (overflowIndex > -1) {
    const foundOverflows = findAllByKind(CellOverflowButton);
    try {
      expect(foundOverflows).toHaveMaxLength(1);
    } catch (e) {
      throw new CompositionTooManyItemsError5(CellOverflowButton, "one at most");
    }
  }
  if (overflowIndex > -1) {
    try {
      expect(foundButtons).toHaveMaxLength(1);
    } catch (e) {
      throw new CompositionTooManyItemsError5(
        CellButton,
        "one at most when using TableActionOverflow"
      );
    }
  }
  if (overflowIndex > -1) {
    try {
      expect(buttonIndex).toBeLessThan(overflowIndex);
    } catch (e) {
      throw new CompositionOrderError4(all[overflowIndex], all[buttonIndex]);
    }
  }
}, "validateActionCell");

// src/organisms/Table/Cells/ActionCell/ActionCell.tsx
import { jsx as jsx34 } from "@emotion/react/jsx-runtime";
var ACTION_CELL_GUTTER = spacing11.s4;
var getStyles21 = /* @__PURE__ */ __name((alignment) => ({
  content: {
    paddingLeft: alignment === "right" /* RIGHT */ ? spacing11.s16 : 0,
    paddingRight: alignment === "left" /* LEFT */ ? spacing11.s16 : 0,
    paddingTop: spacing11.s4,
    paddingBottom: spacing11.s4
  }
}), "getStyles");
var validator5 = new CompositionValidator5([validateActionCell]);
var ActionCell = /* @__PURE__ */ __name((props) => {
  const { children, alignment } = props;
  const styles = getStyles21(alignment);
  validator5.validate(children);
  return /* @__PURE__ */ jsx34(CellBase, __spreadProps(__spreadValues({ styles, gutterPx: ACTION_CELL_GUTTER }, props), { children }));
}, "ActionCell");
ActionCell.displayName = "ActionCell";

// src/organisms/Table/Cells/ContentCell/CellLink/CellLink.tsx
import { forwardRef as forwardRef19 } from "react";
import { combineStyles as combineStyles14, useTheme as useTheme16 } from "@instacart/ids-core";
import { jsx as jsx35 } from "@emotion/react/jsx-runtime";
var getStyles22 = /* @__PURE__ */ __name((theme) => ({
  a: {
    color: theme.colors.systemGrayscale70
  }
}), "getStyles");
var CellLink = forwardRef19(/* @__PURE__ */ __name(function CellLink2(_a, ref) {
  var _b = _a, { children, styles, href, title } = _b, rest = __objRest(_b, ["children", "styles", "href", "title"]);
  const theme = useTheme16();
  const { a } = combineStyles14(getStyles22(theme), styles);
  return /* @__PURE__ */ jsx35("a", __spreadProps(__spreadValues({ css: a, href, ref }, rest), { children: /* @__PURE__ */ jsx35(CellText, { title, children }) }));
}, "CellLink"));
CellLink.displayName = "CellLink";

// src/organisms/Table/Cells/ContentCell/CellImageSmall/CellImageSmall.tsx
import { useTheme as useTheme17, spacing as spacing12 } from "@instacart/ids-core";
import { jsx as jsx36 } from "@emotion/react/jsx-runtime";
var getStyles23 = /* @__PURE__ */ __name((theme) => ({
  image: {
    width: spacing12.s24,
    height: spacing12.s24,
    borderRadius: theme.radius.r4
  }
}), "getStyles");
var CellImageSmall = /* @__PURE__ */ __name((props) => {
  const theme = useTheme17();
  const styles = getStyles23(theme);
  return /* @__PURE__ */ jsx36(CellImageBase, __spreadValues({ styles }, props));
}, "CellImageSmall");

// src/organisms/Table/Cells/ContentCell/CellImageLarge/CellImageLarge.tsx
import { useTheme as useTheme18, spacing as spacing13 } from "@instacart/ids-core";
import { jsx as jsx37 } from "@emotion/react/jsx-runtime";
var getStyles24 = /* @__PURE__ */ __name((theme) => ({
  image: {
    width: spacing13.s40,
    height: spacing13.s40,
    borderRadius: theme.radius.r8
  }
}), "getStyles");
var CellImageLarge = /* @__PURE__ */ __name((props) => {
  const theme = useTheme18();
  const styles = getStyles24(theme);
  return /* @__PURE__ */ jsx37(CellImageBase, __spreadValues({ styles }, props));
}, "CellImageLarge");

// src/organisms/Table/Cells/ContentCell/ContentCell.tsx
import { CompositionValidator as CompositionValidator6 } from "@instacart/ids-core";

// src/organisms/Table/Cells/ContentCell/validations.ts
import {
  CompositionEngineItemType as CompositionEngineItemType2,
  CompositionInvalidChildError as CompositionInvalidChildError2,
  CompositionOrderError as CompositionOrderError5,
  CompositionTooManyItemsError as CompositionTooManyItemsError6,
  CompositionXorItemsError as CompositionXorItemsError3
} from "@instacart/ids-core";
var { TextContent } = CompositionEngineItemType2;
var validateContentCellNumber = /* @__PURE__ */ __name((engine) => {
  const { getAll, expect, findAllByKind, flatIndexOfByKind, childIndexOfByItemType } = engine;
  const all = getAll();
  const textIndex = flatIndexOfByKind(CellText);
  const unwrappedTextIndex = childIndexOfByItemType(TextContent);
  const linkIndex = flatIndexOfByKind(CellLink);
  const iconIndex = flatIndexOfByKind(CellIcon);
  const baseImageIndex = flatIndexOfByKind(CellImageBase);
  const smallImageIndex = flatIndexOfByKind(CellImageSmall);
  const largeImageIndex = flatIndexOfByKind(CellImageLarge);
  const foundTexts = findAllByKind(CellText);
  const foundLinks = findAllByKind(CellLink);
  const foundIcons = findAllByKind(CellIcon);
  const foundBaseImages = findAllByKind(CellImageBase);
  const foundSmallImages = findAllByKind(CellImageSmall);
  const foundLargeImages = findAllByKind(CellImageLarge);
  const graphicIndicesFound = [iconIndex, baseImageIndex, smallImageIndex, largeImageIndex].filter(
    (i) => i > -1
  ).length;
  if (graphicIndicesFound > 1) {
    throw new CompositionXorItemsError3([CellImageBase, CellImageSmall, CellImageLarge, CellIcon]);
  }
  const textIndicesFound = [textIndex, linkIndex].filter((i) => i > -1).length;
  if (textIndicesFound > 1) {
    throw new CompositionXorItemsError3([CellText, CellLink]);
  }
  if (unwrappedTextIndex > -1) {
    throw new CompositionInvalidChildError2(
      all[unwrappedTextIndex],
      "text must be wrapped in CellText"
    );
  }
  try {
    expect(foundTexts).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellText, "one at most");
  }
  try {
    expect(foundLinks).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellLink, "one at most");
  }
  try {
    expect(foundIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellIcon, "one at most");
  }
  try {
    expect(foundBaseImages).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellImageBase, "one at most");
  }
  try {
    expect(foundSmallImages).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellImageSmall, "one at most");
  }
  try {
    expect(foundLargeImages).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError6(CellImageLarge, "one at most");
  }
}, "validateContentCellNumber");
var validateContentCellOrder = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind } = engine;
  const all = getAll();
  const textIndex = flatIndexOfByKind(CellText);
  const linkIndex = flatIndexOfByKind(CellLink);
  const iconIndex = flatIndexOfByKind(CellIcon);
  const baseImageIndex = flatIndexOfByKind(CellImageBase);
  const smallImageIndex = flatIndexOfByKind(CellImageSmall);
  const largeImageIndex = flatIndexOfByKind(CellImageLarge);
  if (iconIndex > -1 && textIndex > -1) {
    try {
      expect(iconIndex).toBeLessThan(textIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[iconIndex], all[textIndex]);
    }
  }
  if (baseImageIndex > -1 && textIndex > -1) {
    try {
      expect(baseImageIndex).toBeLessThan(textIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[baseImageIndex], all[textIndex]);
    }
  }
  if (smallImageIndex > -1 && textIndex > -1) {
    try {
      expect(smallImageIndex).toBeLessThan(textIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[smallImageIndex], all[textIndex]);
    }
  }
  if (largeImageIndex > -1 && textIndex > -1) {
    try {
      expect(largeImageIndex).toBeLessThan(textIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[largeImageIndex], all[textIndex]);
    }
  }
  if (iconIndex > -1 && linkIndex > -1) {
    try {
      expect(iconIndex).toBeLessThan(linkIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[iconIndex], all[linkIndex]);
    }
  }
  if (baseImageIndex > -1 && linkIndex > -1) {
    try {
      expect(baseImageIndex).toBeLessThan(linkIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[baseImageIndex], all[linkIndex]);
    }
  }
  if (smallImageIndex > -1 && linkIndex > -1) {
    try {
      expect(smallImageIndex).toBeLessThan(linkIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[smallImageIndex], all[linkIndex]);
    }
  }
  if (largeImageIndex > -1 && linkIndex > -1) {
    try {
      expect(largeImageIndex).toBeLessThan(linkIndex);
    } catch (e) {
      throw new CompositionOrderError5(all[largeImageIndex], all[linkIndex]);
    }
  }
}, "validateContentCellOrder");

// src/organisms/Table/Cells/ContentCell/ContentCell.tsx
import { jsx as jsx38 } from "@emotion/react/jsx-runtime";
var CONTENT_CELL_GUTTER_PX = 10;
var validator6 = new CompositionValidator6([validateContentCellNumber, validateContentCellOrder]);
var ContentCell = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  validator6.validate(children);
  return /* @__PURE__ */ jsx38(CellBase, __spreadProps(__spreadValues({ gutterPx: CONTENT_CELL_GUTTER_PX }, rest), { children }));
}, "ContentCell");
ContentCell.displayName = "ContentCell";

// src/organisms/Table/Cells/HeaderCell/HeaderCell.tsx
import { jsx as jsx39 } from "@emotion/react/jsx-runtime";
var HeaderCell = /* @__PURE__ */ __name((props) => {
  return /* @__PURE__ */ jsx39(HeaderCellBase, __spreadValues({}, props));
}, "HeaderCell");
HeaderCell.displayName = "HeaderCell";

// src/organisms/Table/Cells/ProgressCell/CellPercentLabel/CellPercentLabel.tsx
import { jsx as jsx40 } from "@emotion/react/jsx-runtime";
var getPercentLabel = /* @__PURE__ */ __name((percent, suffix = "") => {
  const num = Math.round((percent + Number.EPSILON) * 100);
  return `${num}% ${suffix}`.trim();
}, "getPercentLabel");
var CellPercentLabel = /* @__PURE__ */ __name(({ percent, suffix }) => {
  const label = getPercentLabel(percent, suffix);
  return /* @__PURE__ */ jsx40(CellText, { title: label, children: label });
}, "CellPercentLabel");

// src/organisms/Table/Cells/ProgressCell/CellProgressBar/CellProgressBar.tsx
import { combineStyles as combineStyles15, useAriaLoading, useTheme as useTheme19, spacing as spacing14 } from "@instacart/ids-core";
import { jsx as jsx41, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
var PROGRESS_BAR_WIDTH = 40;
var heightStyle = { height: spacing14.s8 };
var getStyles25 = /* @__PURE__ */ __name((theme, percent) => ({
  barBase: __spreadValues({
    fill: theme.colors.systemGrayscale20,
    width: PROGRESS_BAR_WIDTH
  }, heightStyle),
  bar: __spreadProps(__spreadValues({
    width: `calc(100% * ${percent})`,
    transition: "0.35s width",
    fill: theme.colors.systemGrayscale50
  }, heightStyle), {
    rx: "4px"
  }),
  container: __spreadValues({
    width: PROGRESS_BAR_WIDTH,
    borderRadius: spacing14.s8
  }, heightStyle)
}), "getStyles");
var CellProgressBar = /* @__PURE__ */ __name(({ styles, percent }) => {
  const theme = useTheme19();
  const { barBase, bar, container } = combineStyles15(getStyles25(theme, percent), styles);
  const ariaLoading = useAriaLoading({ currentProgressValue: percent * 100 });
  return /* @__PURE__ */ jsxs4("svg", __spreadProps(__spreadValues({ css: container }, ariaLoading), { children: [
    /* @__PURE__ */ jsx41("rect", { css: barBase }),
    /* @__PURE__ */ jsx41("rect", { css: bar, "data-testid": "progress-bar" })
  ] }));
}, "CellProgressBar");

// src/organisms/Table/Cells/ProgressCell/CellProgressRing/CellProgressRing.tsx
import { combineStyles as combineStyles16, useAriaLoading as useAriaLoading2, useTheme as useTheme20 } from "@instacart/ids-core";
import { jsx as jsx42, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
var PROGRESS_RING_SIZE = 24;
var RADIUS = 10;
var CIRCUMFERENCE = RADIUS * 2 * Math.PI;
var svgCircleCss = {
  strokeWidth: 3,
  strokeDasharray: `${CIRCUMFERENCE},${CIRCUMFERENCE}`,
  fill: "transparent",
  r: RADIUS,
  cx: 12,
  cy: 12
};
var getStyles26 = /* @__PURE__ */ __name((theme, p) => ({
  ring: __spreadValues({
    strokeDashoffset: CIRCUMFERENCE * (1 - p),
    transition: "0.35s stroke-dashoffset",
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%",
    stroke: theme.colors.systemGrayscale50
  }, svgCircleCss),
  ringBase: __spreadValues({
    stroke: theme.colors.systemGrayscale20
  }, svgCircleCss),
  container: {
    width: PROGRESS_RING_SIZE,
    height: PROGRESS_RING_SIZE
  }
}), "getStyles");
var CellProgressRing = /* @__PURE__ */ __name(({ styles, percent }) => {
  const theme = useTheme20();
  const { ringBase, ring, container } = combineStyles16(getStyles26(theme, percent), styles);
  const ariaLoading = useAriaLoading2({ currentProgressValue: percent * 100 });
  return /* @__PURE__ */ jsxs5("svg", __spreadProps(__spreadValues({ css: container }, ariaLoading), { children: [
    /* @__PURE__ */ jsx42("circle", { css: ringBase }),
    /* @__PURE__ */ jsx42("circle", { css: ring, "data-testid": "progress-ring" })
  ] }));
}, "CellProgressRing");

// src/organisms/Table/Cells/ProgressCell/ProgressCell.tsx
import { CompositionValidator as CompositionValidator7 } from "@instacart/ids-core";

// src/organisms/Table/Cells/ProgressCell/validations.tsx
import {
  CompositionOrderError as CompositionOrderError6,
  CompositionTooFewItemsError as CompositionTooFewItemsError4,
  CompositionTooManyItemsError as CompositionTooManyItemsError7,
  CompositionXorItemsError as CompositionXorItemsError4
} from "@instacart/ids-core";
var validateProgressCellNumber = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind } = engine;
  const textIndex = flatIndexOfByKind(CellText);
  const percentLabelIndex = flatIndexOfByKind(CellPercentLabel);
  const ringIndex = flatIndexOfByKind(CellProgressRing);
  const barIndex = flatIndexOfByKind(CellProgressBar);
  const foundTexts = findAllByKind(CellText);
  const foundPercentLabels = findAllByKind(CellPercentLabel);
  const foundRings = findAllByKind(CellProgressRing);
  const foundBars = findAllByKind(CellProgressBar);
  const graphicIndicesFound = [ringIndex, barIndex].filter((i) => i > -1).length;
  if (graphicIndicesFound > 1) {
    throw new CompositionXorItemsError4([CellProgressRing, CellProgressBar]);
  }
  const textIndicesFound = [textIndex, percentLabelIndex].filter((i) => i > -1).length;
  if (textIndicesFound > 1) {
    throw new CompositionXorItemsError4([CellText, CellPercentLabel]);
  }
  try {
    expect(foundTexts).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError7(CellText, "one at most");
  }
  try {
    expect(foundPercentLabels).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError7(CellPercentLabel, "one at most");
  }
  try {
    expect(foundRings).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError7(CellProgressRing, "one at most");
  }
  try {
    expect(foundBars).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError7(CellProgressBar, "one at most");
  }
}, "validateProgressCellNumber");
var validateProgressCellOrder = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind } = engine;
  const all = getAll();
  const textIndex = flatIndexOfByKind(CellText);
  const percentLabelIndex = flatIndexOfByKind(CellPercentLabel);
  const ringIndex = flatIndexOfByKind(CellProgressRing);
  const barIndex = flatIndexOfByKind(CellProgressBar);
  if (ringIndex > -1 && percentLabelIndex > -1) {
    try {
      expect(ringIndex).toBeLessThan(percentLabelIndex);
    } catch (e) {
      throw new CompositionOrderError6(all[ringIndex], all[percentLabelIndex]);
    }
  }
  if (ringIndex > -1 && percentLabelIndex === -1) {
    throw new CompositionTooFewItemsError4(CellPercentLabel, "one at most");
  }
  if (ringIndex > -1 && textIndex > -1) {
    throw new CompositionTooManyItemsError7(CellText, "exactly zero");
  }
  if (barIndex > -1 && textIndex > -1) {
    try {
      expect(barIndex).toBeLessThan(textIndex);
    } catch (e) {
      throw new CompositionOrderError6(all[barIndex], all[textIndex]);
    }
  }
  if (barIndex > -1 && textIndex === -1) {
    throw new CompositionTooFewItemsError4(CellText, "one at most");
  }
  if (barIndex > -1 && percentLabelIndex > -1) {
    throw new CompositionTooManyItemsError7(CellPercentLabel, "exactly zero");
  }
}, "validateProgressCellOrder");

// src/organisms/Table/Cells/ProgressCell/ProgressCell.tsx
import { jsx as jsx43 } from "@emotion/react/jsx-runtime";
var validator7 = new CompositionValidator7([validateProgressCellNumber, validateProgressCellOrder]);
var ProgressCell = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  validator7.validate(children);
  return /* @__PURE__ */ jsx43(CellBase, __spreadProps(__spreadValues({}, rest), { children }));
}, "ProgressCell");
ProgressCell.displayName = "ProgressCell";

// src/organisms/Table/Cells/SelectionCell/CellSwitch/CellSwitch.tsx
import { forwardRef as forwardRef20 } from "react";
import { SwitchBase } from "@instacart/ids-core";
import { jsx as jsx44 } from "@emotion/react/jsx-runtime";
var getStyles27 = /* @__PURE__ */ __name(() => ({
  container: {
    verticalAlign: "middle"
  }
}), "getStyles");
var CellSwitch = forwardRef20(/* @__PURE__ */ __name(function CellSwitch2(props, ref) {
  const styles = getStyles27();
  return /* @__PURE__ */ jsx44(SwitchBase, __spreadProps(__spreadValues({ ref }, props), { styles }));
}, "CellSwitch"));
CellSwitch.displayName = "CellSwitch";

// src/organisms/Table/Cells/SelectionCell/CellCheckbox/CellCheckbox.tsx
import { forwardRef as forwardRef21 } from "react";
import { CheckboxBase as CheckboxBase2 } from "@instacart/ids-core";
import { jsx as jsx45 } from "@emotion/react/jsx-runtime";
var getStyles28 = /* @__PURE__ */ __name(() => ({
  container: {
    verticalAlign: "middle",
    marginRight: 0
  }
}), "getStyles");
var CellCheckbox = forwardRef21(/* @__PURE__ */ __name(function CellCheckbox2(props, ref) {
  const styles = getStyles28();
  return /* @__PURE__ */ jsx45(CheckboxBase2, __spreadProps(__spreadValues({ ref }, props), { styles }));
}, "CellCheckbox"));
CellCheckbox.displayName = "CellCheckbox";

// src/organisms/Table/Cells/SelectionCell/SelectionCell.tsx
import { CompositionValidator as CompositionValidator8, spacing as spacing15 } from "@instacart/ids-core";

// src/organisms/Table/Cells/SelectionCell/validations.ts
import {
  CompositionXorItemsError as CompositionXorItemsError5,
  CompositionTooManyItemsError as CompositionTooManyItemsError8
} from "@instacart/ids-core";
var validateSelectionCell = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind } = engine;
  const allCheckboxes = findAllByKind(CellCheckbox);
  const allSwitches = findAllByKind(CellSwitch);
  try {
    expect(allCheckboxes).toHaveMaxLength(1);
  } catch (e) {
    const addtl = "up to one";
    throw new CompositionTooManyItemsError8(CellCheckbox, addtl);
  }
  try {
    expect(allSwitches).toHaveMaxLength(1);
  } catch (e) {
    const addtl = "up to one";
    throw new CompositionTooManyItemsError8(CellSwitch, addtl);
  }
  const bothExist = allCheckboxes.length > 0 && allSwitches.length > 0;
  if (bothExist) {
    throw new CompositionXorItemsError5([CellSwitch, CellSwitch]);
  }
}, "validateSelectionCell");

// src/organisms/Table/Cells/SelectionCell/SelectionCell.tsx
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
var TABLE_SELECTION_GUTTER = 0;
var getStyles29 = /* @__PURE__ */ __name((alignment) => ({
  content: {
    paddingRight: alignment === "right" ? spacing15.s16 : spacing15.s8
  }
}), "getStyles");
var validator8 = new CompositionValidator8([validateSelectionCell]);
var SelectionCell = /* @__PURE__ */ __name((props) => {
  const { alignment, children } = props;
  const styles = getStyles29(alignment);
  validator8.validate(children);
  return /* @__PURE__ */ jsx46(CellBase, __spreadProps(__spreadValues({}, props), { styles, gutterPx: TABLE_SELECTION_GUTTER, children }));
}, "SelectionCell");
SelectionCell.displayName = "SelectionCell";

// src/organisms/Table/Cells/StatusCell/CellApprovedIcon/CellApprovedIcon.tsx
import { ApprovedIcon } from "@instacart/ids-core";
import { jsx as jsx47 } from "@emotion/react/jsx-runtime";
var CellApprovedIcon = /* @__PURE__ */ __name((props) => /* @__PURE__ */ jsx47(
  CellIcon,
  __spreadValues({
    "aria-hidden": true,
    component: /* @__PURE__ */ jsx47(ApprovedIcon, {}),
    color: "brandPrimaryRegular",
    "data-testid": "approved-icon"
  }, props)
), "CellApprovedIcon");

// src/organisms/Table/Cells/StatusCell/CellDefaultIcon/CellDefaultIcon.tsx
import { InformationIcon as InformationIcon2 } from "@instacart/ids-core";
import { jsx as jsx48 } from "@emotion/react/jsx-runtime";
var CellDefaultIcon = /* @__PURE__ */ __name((props) => /* @__PURE__ */ jsx48(
  CellIcon,
  __spreadValues({
    "aria-hidden": true,
    component: /* @__PURE__ */ jsx48(InformationIcon2, {}),
    color: "brandSecondaryRegular",
    "data-testid": "default-icon"
  }, props)
), "CellDefaultIcon");

// src/organisms/Table/Cells/StatusCell/CellInfoIcon/CellInfoIcon.tsx
import { InformationIcon as InformationIcon3 } from "@instacart/ids-core";
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
var CellInfoIcon = /* @__PURE__ */ __name((props) => /* @__PURE__ */ jsx49(
  CellIcon,
  __spreadValues({
    "aria-hidden": true,
    component: /* @__PURE__ */ jsx49(InformationIcon3, {}),
    color: "brandHighlightRegular",
    "data-testid": "info-icon"
  }, props)
), "CellInfoIcon");

// src/organisms/Table/Cells/StatusCell/CellIssueIcon/CellIssueIcon.tsx
import { IssueIcon } from "@instacart/ids-core";
import { jsx as jsx50 } from "@emotion/react/jsx-runtime";
var CellIssueIcon = /* @__PURE__ */ __name((props) => /* @__PURE__ */ jsx50(
  CellIcon,
  __spreadValues({
    "aria-hidden": true,
    component: /* @__PURE__ */ jsx50(IssueIcon, {}),
    color: "systemDetrimentalRegular",
    "data-testid": "issue-icon"
  }, props)
), "CellIssueIcon");

// src/organisms/Table/Cells/StatusCell/StatusCell.tsx
import { CompositionValidator as CompositionValidator9 } from "@instacart/ids-core";

// src/organisms/Table/Cells/StatusCell/validations.tsx
import {
  CompositionOrderError as CompositionOrderError7,
  CompositionTooManyItemsError as CompositionTooManyItemsError9,
  CompositionTooFewItemsError as CompositionTooFewItemsError5,
  CompositionXorItemsError as CompositionXorItemsError6
} from "@instacart/ids-core";
var validateStatusCellNumber = /* @__PURE__ */ __name((engine) => {
  const { expect, findAllByKind, flatIndexOfByKind } = engine;
  const approvedIndex = flatIndexOfByKind(CellApprovedIcon);
  const issueIndex = flatIndexOfByKind(CellIssueIcon);
  const infoIndex = flatIndexOfByKind(CellInfoIcon);
  const defaultIndex = flatIndexOfByKind(CellDefaultIcon);
  const foundTexts = findAllByKind(CellText);
  const foundApprovedIcons = findAllByKind(CellApprovedIcon);
  const foundIssueIcons = findAllByKind(CellIssueIcon);
  const foundInfoIcons = findAllByKind(CellInfoIcon);
  const foundDefaultIcons = findAllByKind(CellDefaultIcon);
  const iconIndicesFound = [approvedIndex, issueIndex, infoIndex, defaultIndex].filter(
    (i) => i > -1
  ).length;
  if (iconIndicesFound > 1 || iconIndicesFound < 1) {
    throw new CompositionXorItemsError6([
      CellApprovedIcon,
      CellIssueIcon,
      CellInfoIcon,
      CellDefaultIcon
    ]);
  }
  try {
    expect(foundTexts).toHaveLength(1);
  } catch (e) {
    if (foundTexts.length > 1) {
      throw new CompositionTooManyItemsError9(CellText, "exactly one");
    }
    if (foundTexts.length < 1) {
      throw new CompositionTooFewItemsError5(CellText, "exactly one");
    }
  }
  try {
    expect(foundApprovedIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError9(CellApprovedIcon, "one at most");
  }
  try {
    expect(foundIssueIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError9(CellIssueIcon, "one at most");
  }
  try {
    expect(foundInfoIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError9(CellInfoIcon, "one at most");
  }
  try {
    expect(foundDefaultIcons).toHaveMaxLength(1);
  } catch (e) {
    throw new CompositionTooManyItemsError9(CellDefaultIcon, "one at most");
  }
}, "validateStatusCellNumber");
var validateStatusCellOrder = /* @__PURE__ */ __name((engine) => {
  const { expect, getAll, flatIndexOfByKind } = engine;
  const all = getAll();
  const textIndex = flatIndexOfByKind(CellText);
  const approvedIndex = flatIndexOfByKind(CellApprovedIcon);
  const issueIndex = flatIndexOfByKind(CellIssueIcon);
  const infoIndex = flatIndexOfByKind(CellInfoIcon);
  const defaultIndex = flatIndexOfByKind(CellDefaultIcon);
  try {
    expect(approvedIndex).toBeLessThan(textIndex);
  } catch (e) {
    throw new CompositionOrderError7(all[approvedIndex], all[textIndex]);
  }
  try {
    expect(issueIndex).toBeLessThan(textIndex);
  } catch (e) {
    throw new CompositionOrderError7(all[issueIndex], all[textIndex]);
  }
  try {
    expect(infoIndex).toBeLessThan(textIndex);
  } catch (e) {
    throw new CompositionOrderError7(all[infoIndex], all[textIndex]);
  }
  try {
    expect(defaultIndex).toBeLessThan(textIndex);
  } catch (e) {
    throw new CompositionOrderError7(all[defaultIndex], all[textIndex]);
  }
}, "validateStatusCellOrder");

// src/organisms/Table/Cells/StatusCell/StatusCell.tsx
import { jsx as jsx51 } from "@emotion/react/jsx-runtime";
var STATUS_LABEL_ID = "status-cell-label";
var STATUS_CELL_GUTTER_PX = 10;
var validator9 = new CompositionValidator9([validateStatusCellNumber, validateStatusCellOrder]);
var StatusCell = /* @__PURE__ */ __name((_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  validator9.validate(children);
  return /* @__PURE__ */ jsx51(CellBase, __spreadProps(__spreadValues({}, rest), { gutterPx: STATUS_CELL_GUTTER_PX, children }));
}, "StatusCell");
StatusCell.displayName = "StatusCell";

// src/organisms/VerticalInputField/VerticalTextInputField.tsx
import { forwardRef as forwardRef22 } from "react";
import { useTheme as useTheme24 } from "@instacart/ids-core";

// src/organisms/VerticalInputField/InputFieldContainer.tsx
import { spacing as spacing17, useTheme as useTheme23 } from "@instacart/ids-core";

// src/organisms/VerticalInputField/InputError.tsx
import { IssueIcon as IssueIcon2, spacing as spacing16, useTheme as useTheme21 } from "@instacart/ids-core";

// src/organisms/VerticalInputField/utils.ts
var hintId = /* @__PURE__ */ __name((inputId) => `${inputId}-hint`, "hintId");
var errorId = /* @__PURE__ */ __name((inputId) => `${inputId}-error`, "errorId");

// src/organisms/VerticalInputField/InputError.tsx
import { jsx as jsx52, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
var getStyles30 = /* @__PURE__ */ __name((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: spacing16.s4
  },
  icon: {
    flex: "none"
  },
  inputDescriptionError: __spreadProps(__spreadValues({}, theme.typography.bodyMedium2), {
    color: theme.colors.systemDetrimentalRegular,
    margin: 0,
    wordBreak: "break-word"
  })
}), "getStyles");
function InputError({ inputId, error }) {
  const theme = useTheme21();
  const styles = getStyles30(theme);
  return /* @__PURE__ */ jsxs6("div", { css: styles.container, children: [
    /* @__PURE__ */ jsx52(IssueIcon2, { size: 16, color: "systemDetrimentalRegular", css: styles.icon }),
    /* @__PURE__ */ jsx52(InputDescriptionErrorText, { id: errorId(inputId), css: styles.inputDescriptionError, children: error })
  ] });
}
__name(InputError, "InputError");

// src/organisms/VerticalInputField/InputHint.tsx
import { useTheme as useTheme22 } from "@instacart/ids-core";
import { jsx as jsx53 } from "@emotion/react/jsx-runtime";
function useStyles2({ disabled }) {
  const theme = useTheme22();
  return {
    inputDescriptionHint: __spreadProps(__spreadValues({}, theme.typography.bodySmall2), {
      color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale50,
      margin: 0
    })
  };
}
__name(useStyles2, "useStyles");
function InputHint({ inputId, hint, disabled }) {
  const styles = useStyles2({ disabled });
  return /* @__PURE__ */ jsx53(
    InputDescriptionHintText,
    {
      id: hintId(inputId),
      css: styles.inputDescriptionHint,
      disabled,
      children: hint
    }
  );
}
__name(InputHint, "InputHint");

// src/organisms/VerticalInputField/InputFieldContainer.tsx
import { jsx as jsx54, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
var useStyles3 = /* @__PURE__ */ __name(({ hideLabel }) => {
  const theme = useTheme23();
  const inputWrapper = {
    container: {
      display: "block",
      marginTop: spacing17.s4
    }
  };
  return {
    labelContainer: {
      display: "flex",
      gap: spacing17.s4,
      alignItems: "center",
      margin: 0
    },
    field: {
      display: "block",
      label: __spreadProps(__spreadValues({}, theme.typography.bodyMedium1), {
        display: hideLabel ? "none" : "block",
        width: "auto",
        height: "auto",
        margin: 0,
        textAlign: "left"
      })
    },
    errorContainer: {
      marginTop: spacing17.s4
    },
    inputWrapper
  };
}, "useStyles");
function InputFieldContainer({
  isOptional,
  label,
  hint,
  id,
  error,
  children,
  hideLabel,
  disabled
}) {
  const styles = useStyles3({ hideLabel });
  return /* @__PURE__ */ jsxs7(Field, { css: styles.field, children: [
    /* @__PURE__ */ jsx54("div", { css: styles.labelContainer, children: /* @__PURE__ */ jsx54(Label, { htmlFor: id, isOptional, disabled, children: label }) }),
    hint && /* @__PURE__ */ jsx54(InputHint, { inputId: id, hint, disabled }),
    /* @__PURE__ */ jsxs7(InputWrapper, { styles: styles.inputWrapper, children: [
      children,
      error && /* @__PURE__ */ jsx54("div", { css: styles.errorContainer, children: error && /* @__PURE__ */ jsx54(InputError, { inputId: id, error }) })
    ] })
  ] });
}
__name(InputFieldContainer, "InputFieldContainer");

// src/organisms/VerticalInputField/VerticalTextInputField.tsx
import { jsx as jsx55 } from "@emotion/react/jsx-runtime";
var VerticalTextInputField = forwardRef22(
  /* @__PURE__ */ __name(function VerticalTextInputField2(_a, ref) {
    var _b = _a, {
      id,
      onChange,
      error,
      invalid,
      isOptional,
      hideLabel,
      disabled,
      readOnly
    } = _b, rest = __objRest(_b, [
      "id",
      "onChange",
      "error",
      "invalid",
      "isOptional",
      "hideLabel",
      "disabled",
      "readOnly"
    ]);
    const theme = useTheme24();
    return /* @__PURE__ */ jsx55(
      InputFieldContainer,
      __spreadProps(__spreadValues({
        id,
        error,
        isOptional,
        hideLabel,
        disabled
      }, rest), {
        children: /* @__PURE__ */ jsx55(
          InputText,
          __spreadValues({
            ref,
            id,
            onChange,
            invalid: invalid || !!error,
            disabled: disabled || readOnly,
            instructionInputTextId: rest.hint && hintId(id),
            style: {
              color: disabled ? theme.colors.systemGrayscale30 : theme.colors.systemGrayscale70
            }
          }, rest)
        )
      })
    );
  }, "VerticalTextInputField")
);

// src/organisms/FeatureHighlight/index.ts
var FeatureHighlight_exports = {};
__export(FeatureHighlight_exports, {
  FeatureHighlight: () => FeatureHighlight,
  FeatureHighlightCloseButton: () => FeatureHighlightCloseButton,
  FeatureHighlightContent: () => FeatureHighlightContent,
  FeatureHighlightDescription: () => FeatureHighlightDescription,
  FeatureHighlightIllustration: () => FeatureHighlightIllustration,
  FeatureHighlightNavigation: () => FeatureHighlightNavigation,
  FeatureHighlightNextButton: () => FeatureHighlightNextButton,
  FeatureHighlightPrevButton: () => FeatureHighlightPrevButton,
  FeatureHighlightProgressText: () => FeatureHighlightProgressText,
  FeatureHighlightTitle: () => FeatureHighlightTitle
});

// src/organisms/FeatureHighlight/FeatureHighlightBase.tsx
import { useTheme as useTheme25, combineStyles as combineStyles17, spacing as spacing18 } from "@instacart/ids-core";

// src/organisms/FeatureHighlight/FeatureHighlightBeacon.tsx
import { keyframes } from "@emotion/react";
import { jsx as jsx56 } from "@emotion/react/jsx-runtime";
var GAP_TO_LEFT = "-30px";
var GAP_TO_RIGHT = "410px";
var beaconStylesByPosition = {
  topLeft: { left: GAP_TO_LEFT, alignItems: "start" },
  middleLeft: { left: GAP_TO_LEFT, alignItems: "center" },
  bottomLeft: { left: GAP_TO_LEFT, alignItems: "end" },
  bottomRight: { left: GAP_TO_RIGHT, alignItems: "end" },
  middleRight: { left: GAP_TO_RIGHT, alignItems: "center" },
  topRight: { left: GAP_TO_RIGHT, alignItems: "start" },
  hidden: { left: "0px", alignItems: "center" }
};
var ripple = keyframes`
    0% {
      left: 5px;
      top: 5px;
      opcity: 75;
      width: 0;
      height: 0;
    }
    100% {
      left: -20px;
      top: -20px;
      opacity: 0;
      width: 48px;
      height: 48px;
    }
 `;
function FeatureHighlightBeacon({ position }) {
  if (position === "hidden") {
    return null;
  }
  const styles = {
    position: "relative",
    left: beaconStylesByPosition[position].left,
    "&:before": {
      content: '" "',
      position: "absolute",
      zIndex: 2,
      left: "-8px",
      top: "-8px",
      width: "24px",
      height: "24px",
      backgroundColor: "#1f5a96",
      borderRadius: "50%"
    },
    "&:after": {
      content: '" "',
      position: "absolute",
      zIndex: 1,
      left: "-8px",
      top: "-8px",
      width: "24px",
      height: "24px",
      backgroundColor: `#1f5a96`,
      borderRadius: "50%",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.3) inset",
      animationName: ripple,
      animationDuration: `1s`,
      animationTimingFunction: "ease",
      animationDelay: "0s",
      animationIterationCount: "infinite",
      animationDirection: "normal"
    }
  };
  return /* @__PURE__ */ jsx56("div", { css: styles });
}
__name(FeatureHighlightBeacon, "FeatureHighlightBeacon");

// src/organisms/FeatureHighlight/FeatureHighlightBase.tsx
import { jsx as jsx57 } from "@emotion/react/jsx-runtime";
var getStyles31 = /* @__PURE__ */ __name((theme, position) => ({
  baseCss: {
    position: "relative",
    boxShadow: `0 0.5em 3em ${theme.colors.systemGrayscale20}`,
    display: "flex",
    width: "396px",
    alignItems: beaconStylesByPosition[position].alignItems,
    borderRadius: spacing18.s12,
    backgroundColor: "white"
  }
}), "getStyles");
function FeatureHighlightBase(_a) {
  var _b = _a, {
    styles,
    position = "topLeft",
    children
  } = _b, rest = __objRest(_b, [
    "styles",
    "position",
    "children"
  ]);
  const theme = useTheme25();
  const { baseCss } = combineStyles17(getStyles31(theme, position), styles);
  return /* @__PURE__ */ jsx57("div", __spreadProps(__spreadValues({ css: baseCss }, rest), { children }));
}
__name(FeatureHighlightBase, "FeatureHighlightBase");

// src/organisms/FeatureHighlight/useFeatureHighlightContext.ts
import { createContext, useContext } from "react";
var FeatureHighlightContext = createContext(void 0);
function useFeatureHighlightContext() {
  const context = useContext(FeatureHighlightContext);
  if (!context)
    throw new Error("useFeatureHighlightContext must be used within a FeatureHighlight");
  return context;
}
__name(useFeatureHighlightContext, "useFeatureHighlightContext");

// src/organisms/FeatureHighlight/FeatureHighlight.tsx
import { jsx as jsx58, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
function FeatureHighlight({
  beaconPosition = "topLeft",
  illustration,
  content,
  navigation,
  currentStep,
  setCurrentStep,
  setIsOpen,
  totalSteps,
  closeButton,
  styles
}) {
  const contextValue = { currentStep, setCurrentStep, setIsOpen, totalSteps };
  return /* @__PURE__ */ jsx58(FeatureHighlightContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsxs8(FeatureHighlightBase, { position: beaconPosition, styles: { baseCss: styles }, children: [
    /* @__PURE__ */ jsx58(FeatureHighlightBeacon, { position: beaconPosition }),
    /* @__PURE__ */ jsxs8("div", { css: { width: "100%" }, children: [
      closeButton,
      illustration,
      content,
      navigation
    ] })
  ] }) });
}
__name(FeatureHighlight, "FeatureHighlight");

// src/organisms/FeatureHighlight/FeatureHighlightDescription.tsx
import { useTheme as useTheme26, combineStyles as combineStyles18 } from "@instacart/ids-core";
import { jsx as jsx59 } from "@emotion/react/jsx-runtime";
var getStyles32 = /* @__PURE__ */ __name((theme) => ({
  divCss: __spreadValues({
    color: theme.colors.systemGrayscale70
  }, theme.typography.bodyLarge2)
}), "getStyles");
function FeatureHighlightDescription(_a) {
  var _b = _a, {
    styles,
    children
  } = _b, rest = __objRest(_b, [
    "styles",
    "children"
  ]);
  const theme = useTheme26();
  const { divCss } = combineStyles18(getStyles32(theme), styles);
  return /* @__PURE__ */ jsx59("div", __spreadProps(__spreadValues({ css: divCss }, rest), { children }));
}
__name(FeatureHighlightDescription, "FeatureHighlightDescription");

// src/organisms/FeatureHighlight/FeatureHighlightTitle.tsx
import { useTheme as useTheme27, combineStyles as combineStyles19, spacing as spacing19 } from "@instacart/ids-core";
import { jsx as jsx60 } from "@emotion/react/jsx-runtime";
var getStyles33 = /* @__PURE__ */ __name((theme) => ({
  textCss: __spreadProps(__spreadValues({
    display: "block",
    color: theme.colors.systemGrayscale70
  }, theme.typography.titleMedium), {
    marginBottom: spacing19.s8
  })
}), "getStyles");
function FeatureHighlightTitle(_a) {
  var _b = _a, {
    styles,
    children
  } = _b, rest = __objRest(_b, [
    "styles",
    "children"
  ]);
  const theme = useTheme27();
  const { textCss } = combineStyles19(getStyles33(theme), styles);
  return /* @__PURE__ */ jsx60("span", __spreadProps(__spreadValues({ css: textCss }, rest), { children }));
}
__name(FeatureHighlightTitle, "FeatureHighlightTitle");

// src/organisms/FeatureHighlight/FeatureHighlightContent.tsx
import { combineStyles as combineStyles20, spacing as spacing20 } from "@instacart/ids-core";
import { jsx as jsx61 } from "@emotion/react/jsx-runtime";
var getStyles34 = /* @__PURE__ */ __name(() => ({
  divCss: { padding: `${spacing20.s16}px ${spacing20.s32}px` }
}), "getStyles");
function FeatureHighlightContent(_a) {
  var _b = _a, {
    styles,
    children
  } = _b, rest = __objRest(_b, [
    "styles",
    "children"
  ]);
  const { divCss } = combineStyles20(getStyles34(), styles);
  return /* @__PURE__ */ jsx61("div", __spreadProps(__spreadValues({ css: divCss }, rest), { children }));
}
__name(FeatureHighlightContent, "FeatureHighlightContent");

// src/organisms/FeatureHighlight/FeatureHighlightProgressText.tsx
import { useTheme as useTheme28, combineStyles as combineStyles21, spacing as spacing21 } from "@instacart/ids-core";
import { jsx as jsx62 } from "@emotion/react/jsx-runtime";
var getStyles35 = /* @__PURE__ */ __name((theme) => ({
  spanCss: __spreadProps(__spreadValues({
    display: "block",
    color: theme.colors.systemGrayscale50
  }, theme.typography.bodyMedium1), {
    marginBottom: spacing21.s8
  })
}), "getStyles");
function FeatureHighlightProgressText(_a) {
  var _b = _a, {
    children,
    styles
  } = _b, rest = __objRest(_b, [
    "children",
    "styles"
  ]);
  const theme = useTheme28();
  const { spanCss } = combineStyles21(getStyles35(theme), styles);
  return /* @__PURE__ */ jsx62("span", __spreadProps(__spreadValues({ css: spanCss }, rest), { children }));
}
__name(FeatureHighlightProgressText, "FeatureHighlightProgressText");

// src/organisms/FeatureHighlight/FeatureHighlightNextButton.tsx
import { combineStyles as combineStyles22, spacing as spacing22 } from "@instacart/ids-core";
import { forwardRef as forwardRef23 } from "react";
import { jsx as jsx63 } from "@emotion/react/jsx-runtime";
var getStyles36 = /* @__PURE__ */ __name(() => ({
  btnCss: { minWidth: "65px", height: "40px", marginRight: spacing22.s24 }
}), "getStyles");
var FeatureHighlightNextButton = forwardRef23(
  /* @__PURE__ */ __name(function FeatureHighlightNextButton2(_a, ref) {
    var _b = _a, { onClick: userProvidedOnClick, children, styles, accessibleLabel } = _b, rest = __objRest(_b, ["onClick", "children", "styles", "accessibleLabel"]);
    const { btnCss } = combineStyles22(getStyles36(), styles);
    const { currentStep, totalSteps, setIsOpen, setCurrentStep } = useFeatureHighlightContext();
    return /* @__PURE__ */ jsx63(
      PrimaryButton,
      __spreadProps(__spreadValues({
        css: btnCss,
        onClick: () => {
          if (currentStep === totalSteps - 1) {
            setIsOpen(false);
          } else {
            setCurrentStep((s) => s + 1);
          }
          userProvidedOnClick == null ? void 0 : userProvidedOnClick({ currentStep, totalSteps, setIsOpen, setCurrentStep });
        },
        ref,
        "aria-label": accessibleLabel
      }, rest), {
        children
      })
    );
  }, "FeatureHighlightNextButton")
);

// src/organisms/FeatureHighlight/FeatureHighlightPrevButton.tsx
import { spacing as spacing23, combineStyles as combineStyles23 } from "@instacart/ids-core";
import { forwardRef as forwardRef24 } from "react";
import { jsx as jsx64 } from "@emotion/react/jsx-runtime";
var getStyles37 = /* @__PURE__ */ __name(() => ({
  btnCss: {
    borderRadius: "100%",
    height: spacing23.s40,
    width: spacing23.s40,
    minWidth: spacing23.s40,
    marginLeft: spacing23.s24,
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }
}), "getStyles");
var FeatureHighlightPrevButton = forwardRef24(
  /* @__PURE__ */ __name(function FeatureHighlightPrevButton2(_a, ref) {
    var _b = _a, { onClick: userProvidedOnClick, children, styles, accessibleLabel } = _b, rest = __objRest(_b, ["onClick", "children", "styles", "accessibleLabel"]);
    const { currentStep, setCurrentStep, setIsOpen, totalSteps } = useFeatureHighlightContext();
    const { btnCss } = combineStyles23(getStyles37(), styles);
    return /* @__PURE__ */ jsx64(
      SecondaryButton,
      __spreadProps(__spreadValues({
        disabled: currentStep === 0,
        css: btnCss,
        onClick: () => {
          setCurrentStep((s) => s - 1);
          userProvidedOnClick == null ? void 0 : userProvidedOnClick({ currentStep, setCurrentStep, setIsOpen, totalSteps });
        },
        ref,
        "aria-label": accessibleLabel
      }, rest), {
        children
      })
    );
  }, "FeatureHighlightPrevButton")
);

// src/organisms/FeatureHighlight/FeatureHighlightNavigation.tsx
import { combineStyles as combineStyles24 } from "@instacart/ids-core";
import { jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
var getStyles38 = /* @__PURE__ */ __name((prevButton) => ({
  divCss: {
    height: "76px",
    display: "flex",
    justifyContent: prevButton ? "space-between" : "end",
    alignItems: "center"
  }
}), "getStyles");
function FeatureHighlightNavigation(_a) {
  var _b = _a, {
    styles,
    prevButton,
    nextButton
  } = _b, rest = __objRest(_b, [
    "styles",
    "prevButton",
    "nextButton"
  ]);
  const { divCss } = combineStyles24(getStyles38(prevButton), styles);
  return /* @__PURE__ */ jsxs9("div", __spreadProps(__spreadValues({ css: divCss }, rest), { children: [
    prevButton,
    nextButton
  ] }));
}
__name(FeatureHighlightNavigation, "FeatureHighlightNavigation");

// src/organisms/FeatureHighlight/FeatureHighlightIllustration.tsx
import { combineStyles as combineStyles25, spacing as spacing24 } from "@instacart/ids-core";
import { jsx as jsx65 } from "@emotion/react/jsx-runtime";
var getStyles39 = /* @__PURE__ */ __name(() => ({
  container: {
    height: "150px",
    overflow: "hidden",
    borderRadius: `${spacing24.s12}px ${spacing24.s12}px 0 0`
  }
}), "getStyles");
function FeatureHighlightIllustration({
  children,
  styles
}) {
  const { container } = combineStyles25(getStyles39(), styles);
  return /* @__PURE__ */ jsx65("div", { css: container, children });
}
__name(FeatureHighlightIllustration, "FeatureHighlightIllustration");

// src/organisms/FeatureHighlight/FeatureHighlightCloseButton.tsx
import { forwardRef as forwardRef25 } from "react";
import { ButtonBase as ButtonBase8, spacing as spacing25, CloseIcon } from "@instacart/ids-core";
import { jsx as jsx66 } from "@emotion/react/jsx-runtime";
var getStyles40 = /* @__PURE__ */ __name(() => ({
  button: {
    cursor: "pointer",
    position: "absolute",
    right: spacing25.s8,
    top: spacing25.s8,
    borderRadius: "100%",
    height: spacing25.s40,
    width: spacing25.s40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "flexStart",
    flexDirection: "column",
    background: "white",
    border: "0px"
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}), "getStyles");
var FeatureHighlightCloseButton = forwardRef25(/* @__PURE__ */ __name(function FeatureHighlightCloseButton2(_a, ref) {
  var _b = _a, { onClick: userProvidedOnClick, accessibleLabel } = _b, rest = __objRest(_b, ["onClick", "accessibleLabel"]);
  const styles = getStyles40();
  const { currentStep, setCurrentStep, setIsOpen, totalSteps } = useFeatureHighlightContext();
  const handleOnClick = /* @__PURE__ */ __name(() => {
    setIsOpen(false);
    userProvidedOnClick == null ? void 0 : userProvidedOnClick({ currentStep, setCurrentStep, setIsOpen, totalSteps });
  }, "handleOnClick");
  return /* @__PURE__ */ jsx66(
    ButtonBase8,
    __spreadProps(__spreadValues({
      ref,
      onClick: handleOnClick,
      styles
    }, rest), {
      "aria-label": accessibleLabel,
      children: /* @__PURE__ */ jsx66(CloseIcon, { size: 24 })
    })
  );
}, "FeatureHighlightCloseButton"));
export {
  ActionCell,
  Align,
  CIRCUMFERENCE,
  CellApprovedIcon,
  CellBase,
  CellButton,
  CellButtonBase,
  CellCheckbox,
  CellDefaultIcon,
  CellIcon,
  CellImageBase,
  CellImageLarge,
  CellImageSmall,
  CellInfoIcon,
  CellIssueIcon,
  CellLink,
  CellOverflowButton,
  CellPercentLabel,
  CellProgressBar,
  CellProgressRing,
  CellSwitch,
  CellText,
  ContentCell,
  DEFAULT_OPTIONAL_TEXT,
  FeatureHighlight,
  FeatureHighlightCloseButton,
  FeatureHighlightContent,
  FeatureHighlightDescription,
  FeatureHighlightIllustration,
  FeatureHighlightNavigation,
  FeatureHighlightNextButton,
  FeatureHighlightPrevButton,
  FeatureHighlightProgressText,
  FeatureHighlightTitle,
  Field,
  FieldBase,
  HeaderCell,
  HeaderCellBase,
  HeaderCheckbox,
  HeaderIcon,
  HeaderSortIcon,
  HeaderSubtitle,
  HeaderTitle,
  HeaderTitleText,
  IconButton,
  IconButtonBase,
  IconInputBase,
  InfoInputIcon,
  InputCurrency,
  InputDescriptionBase,
  InputDescriptionErrorText,
  InputDescriptionHintText,
  InputPercent,
  InputSearch,
  InputText,
  InputWrapper,
  LABEL_WIDTH,
  Label,
  LabelBase,
  PrimaryButton,
  ProgressCell,
  STATUS_LABEL_ID,
  SecondaryButton,
  SelectionCell,
  SortState,
  StatusCell,
  TableWrapper,
  VerticalTextInputField,
  FeatureHighlight_exports as unstableFeatureHighlight,
  InfoInputIcon_exports as unstableInfoInputIcon
};
